/**
 * Archivo de localización: ES
 * Míster 11 - Sistema de Localización Canónico
 */

export const es = {
  "ach.biweekly_fit.desc": "Registra o supera tu mejor marca en las pruebas físicas del equipo.",
  "ach.biweekly_fit.name": "Evolución Física",
  "ach.biweekly_iron.desc": "100% de asistencia durante 14 días consecutivos.",
  "ach.biweekly_iron.name": "Jugador de Hierro",
  "ach.biweekly_self_care.desc": "Envía tu check-in de bienestar en al menos el 80% de los días.",
  "ach.biweekly_self_care.name": "Hábito Saludable",
  "ach.biweekly_strong_mind.desc": "Realiza 3 tests psicológicos de afrontamiento o fortaleza mental.",
  "ach.biweekly_strong_mind.name": "Resiliencia de Competición",
  "ach.biweekly_teammate.desc": "Confirma tu asistencia (RSVP) a todos los eventos con antelación.",
  "ach.biweekly_teammate.name": "Compromiso con el Grupo",
  "ach.gold_cone_memory.desc": "Recuerda y reproduce una secuencia de al menos 6 conos en Memoria de Conos.",
  "ach.gold_cone_memory.name": "Memoria de Campeonato",
  "ach.gold_impulse_brake.desc": "Alcanza un 90% o más de precisión en el juego Freno Impulsivo.",
  "ach.gold_impulse_brake.name": "Freno de Oro",
  "ach.gold_tactical_eye.desc": "Logra un pleno de 5/5 aciertos en Ojo Táctico encontrando al compañero libre.",
  "ach.gold_tactical_eye.name": "Ojo de Halcón",
  "ach.season_analyst.desc": "Completa todos los cuestionarios y evaluaciones del catálogo.",
  "ach.season_analyst.name": "Máster Táctico y Psicológico",
  "ach.season_assist.desc": "Reparte asistencias de gol decisivas a tus compañeros.",
  "ach.season_assist.name": "Motor del Equipo",
  "ach.season_captain.desc": "100% de asistencia a entrenamientos y partidos durante un mes completo.",
  "ach.season_captain.name": "Espíritu de Capitán",
  "ach.season_mental_squad.desc": "Logro colectivo: el equipo acumula 20 o más sesiones cognitivas completadas.",
  "ach.season_mental_squad.name": "Equipo Mental",
  "ach.season_scorer.desc": "Alcanza el objetivo de goles marcados en competición oficial.",
  "ach.season_scorer.name": "Goleador de Temporada",
  "ach.season_unstoppable.desc": "Mantén una racha activa de 21 días de constancia deportiva.",
  "ach.season_unstoppable.name": "Racha Imparable",
  "ach.season_veteran.desc": "Participa o acude convocado al menos al 80% de los partidos del año.",
  "ach.season_veteran.name": "Veterano de la Temporada",
  "ach.weekly_attentive.desc": "Consulta los detalles del próximo partido o entrenamiento antes de la citación.",
  "ach.weekly_attentive.name": "Siempre Atento",
  "ach.weekly_committed.desc": "Completa los ejercicios de tu plan individual asignado.",
  "ach.weekly_committed.name": "Trabajo Invisible",
  "ach.weekly_mind_active.desc": "Completa al menos 3 sesiones de entrenamiento cognitivo o retos esta semana.",
  "ach.weekly_mind_active.name": "Mente Activa",
  "ach.weekly_perfect_week.desc": "Asiste al 100% de las sesiones de entrenamiento programadas esta semana.",
  "ach.weekly_perfect_week.name": "Semana Perfecta",
  "ach.weekly_scholar.desc": "Completa al menos 1 test psicológico o evaluación en el portal.",
  "ach.weekly_scholar.name": "Mente Fuerte",
  "ach.weekly_wellness.desc": "Registra tu estado de descanso y molestias en los días de entrenamiento.",
  "ach.weekly_wellness.name": "Check-in de Salud",
  "ach.weekly_zen.desc": "Completa la Respiración 4-4 en al menos 3 días distintos en la semana.",
  "ach.weekly_zen.name": "Zen",
  "achievements.toast_unlocked": "¡Logro desbloqueado: {name}! (+{xp} XP)",
  "admin.account_deleted": "Tu cuenta de entrenador y datos han sido eliminados correctamente.",
  "admin.ai.desc": "Configura la clave API de Groq para que la IA Generadora funcione en todos los dispositivos (incluyendo el APK de la tablet sin necesidad de recompilar).",
  "admin.ai.keyLabel": "Clave API de Groq (gsk_...)",
  "admin.ai.saveKey": "GUARDAR CLAVE",
  "admin.ai.title": "Configuración de IA (Groq)",
  "admin.already_latest": "✅ Ya tienes la última versión instalada (v{version}).",
  "admin.apk.desc": "Instala Mister11 directamente en tu tablet Android",
  "admin.apk.downloadBtn": "DESCARGAR APK",
  "admin.apk.instructions": "Solo para Android · Habilita 'Fuentes desconocidas' en Ajustes del sistema antes de instalar",
  "admin.apk.title": "Aplicación Android (APK)",
  "admin.apk_download_done": "✅ Descarga completada. Busca el archivo en tu carpeta de Descargas e instálalo.",
  "admin.apk_download_fallback": "⚠️ Descarga directa fallida. Abriendo enlace alternativo...",
  "admin.apk_download_start": "⬇️ Iniciando descarga del APK...",
  "admin.backup_error": "Error al generar la copia de seguridad.",
  "admin.groq_api_error": "Error al guardar la clave API en Firestore.",
  "admin.groq_api_saved": "¡Clave API de Groq guardada con éxito!",
  "admin.lang.title": "Idioma del Sistema",
  "admin.manageSubAndroidMsg": "Gestiona tu suscripción desde mister11.app",
  "admin.match_not_found": "Partido no encontrado.",
  "admin.no_active_team": "No hay ningún equipo activo seleccionado.",
  "admin.no_players": "No hay jugadores en el equipo activo.",
  "admin.notif.title": "Notificaciones",
  "admin.pref.checkUpdates": "Buscar actualizaciones",
  "admin.pref.checking": "Comprobando...",
  "admin.pref.darkMode": "Modo Oscuro",
  "admin.pref.reminders": "Recordatorios de Sesión",
  "admin.pref.remindersDescApk": "Disponible en la aplicación Android (APK).",
  "admin.pref.remindersDescNative": "Recibirás una notificación 1 hora antes de cada sesión de entrenamiento.",
  "admin.pref.systemLang": "IDIOMA DEL SISTEMA",
  "admin.pref.title": "Preferencias",
  "admin.pref.version": "Versión actual de la app",
  "admin.profile_error": "Error al guardar perfil.",
  "admin.profile_synced": "Perfil de entrenador sincronizado en todo el sistema.",
  "admin.report_error": "Error al generar el informe global.",
  "admin.section.equipos": "Gestión de Equipos",
  "admin.select_match_first": "Selecciona un partido primero.",
  "admin.select_session_first": "Selecciona una sesión primero.",
  "admin.select_team_first": "Selecciona un equipo primero.",
  "admin.session_not_found": "Sesión no encontrada.",
  "admin.settings.category": "CATEGORÍA",
  "admin.settings.coachProfile": "Perfil del Entrenador",
  "admin.settings.cookies": "Cookies",
  "admin.settings.copyConsentBtn": "🔗 Copiar Link de Consentimiento Digital",
  "admin.settings.deleteAccountGdpr": "Excluir Cuenta y Datos (RGPD)",
  "admin.settings.downloadConsentBtn": "Descargar Consentimiento Parental (Imprimible)",
  "admin.settings.fullName": "Nombre Completo",
  "admin.settings.inviteStaffBtn": "Copiar / Compartir Link para Invitar Entrenadores",
  "admin.settings.legalDesc": "Descarga plantillas legales obligatorias y gestiona el consentimiento informado para los padres de tus jugadores menores de edad.",
  "admin.settings.legalTitle": "Centro Legal y Consentimientos",
  "admin.settings.manageStaffBtn": "Ver y Gestionar Todo el Cuerpo Técnico",
  "admin.settings.primaryColor": "COLOR PRINCIPAL",
  "admin.settings.privacy": "Privacidad",
  "admin.settings.roleAnalyst": "Analista Táctico",
  "admin.settings.roleAssistant3": "Ayudante / 3er Entrenador",
  "admin.settings.roleAssistantCoach": "Segundo Entrenador",
  "admin.settings.roleFitnessCoach": "Preparador Físico",
  "admin.settings.roleHeadCoach": "Primer Entrenador (Admin)",
  "admin.settings.rolePhysio": "Fisioterapeuta / Médico",
  "admin.settings.rolePlayer": "Jugador",
  "admin.settings.roleSpecialty": "Rol / Especialidad en el Equipo",
  "admin.settings.saveIdentity": "SALVAR Identidad",
  "admin.settings.saveProfile": "SALVAR Perfil y Rol",
  "admin.settings.season": "TEMPORADA",
  "admin.settings.secondaryColor": "COLOR SECUNDARIO",
  "admin.settings.subtitle": "Personaliza tu experiencia y la identidad visual de tu club.",
  "admin.settings.teamBadge": "ESCUDO DEL EQUIPO",
  "admin.settings.teamIdentity": "Identidad del Equipo",
  "admin.settings.teamName": "NOMBRE DEL EQUIPO",
  "admin.settings.terms": "Términos",
  "admin.settings.title": "Ajustes del Sistema",
  "admin.settings.uploadImage": "Subir Imagen",
  "admin.shield_error": "No se pudo subir o procesar la imagen.",
  "admin.shield_saved": "¡Escudo guardado y optimizado con éxito!",
  "admin.svg_shield_saved": "¡Escudo vectorial SVG guardado con éxito!",
  "admin.tab.ajustes": "Ajustes",
  "admin.tab.club": "Club",
  "admin.tab.ejercicios": "Ejercicios",
  "admin.tab.equipos": "Equipos",
  "admin.tab.exportar": "Exportar",
  "admin.tab.general": "General",
  "admin.tab.suscripcion": "Suscripción",
  "admin.team_identity_error": "Error al actualizar identidad del equipo.",
  "admin.team_identity_updated": "Identidad del equipo actualizada correctamente.",
  "admin.theme.dark": "Modo Oscuro",
  "admin.title": "Panel de Administración",
  "admin.update_check_error": "No se pudo comprobar actualizaciones.",
  "admin.update_connect_error": "Error al conectar con el servidor.",
  "admin.xp.absent": "XP Ausente",
  "admin.xp.desc": "Configura los puntos de XP que suma cada jugador por estado de asistencia confirmado y los objetivos de temporada del equipo.",
  "admin.xp.excused": "XP Justificado",
  "admin.xp.goals": "Objetivo Goles Temporada",
  "admin.xp.late": "XP Tarde",
  "admin.xp.present": "XP Presente",
  "admin.xp.saveBtn": "Configuración de XP",
  "admin.xp.title": "Temporada y Tabla de XP Diferenciada",
  "admin.xp.veteran": "% Partidos Veterano",
  "admin.xp_error": "Error al guardar configuración de XP.",
  "admin.xp_saved": "Tabla de XP y objetivos de temporada guardados con éxito.",
  "analisis.btnExportPdf": "Exportar Análisis PDF",
  "analisis.chart.axisCounterEff": "Eficacia Contras",
  "analisis.chart.axisDuels": "% Duelos",
  "analisis.chart.axisLossControl": "Control Pérdidas",
  "analisis.chart.axisRecoveries": "Recuperaciones",
  "analisis.chart.axisShots": "Tiros a Puerta",
  "analisis.chart.bars": "Comparativa Directa de Eventos",
  "analisis.chart.duels": "% Duelos Ganados",
  "analisis.chart.losses": "Pérdidas",
  "analisis.chart.radar": "Radar de Perfil Táctico Promedio",
  "analisis.chart.recoveries": "Recuperaciones",
  "analisis.chart.shotsOwn": "Tiros Propios",
  "analisis.chart.shotsOwnTitle": "Tiros a Puerta Propios",
  "analisis.chart.shotsRival": "Tiros Rival",
  "analisis.chart.trend": "Evolución y Tendencia de Rendimiento",
  "analisis.exportPdf": "Descargar PDF Análisis",
  "analisis.exportingPdf": "Generando PDF...",
  "analisis.kpi.counters": "Efectividad Contraataque",
  "analisis.kpi.countersSub": "Ratio de conversión de recuperaciones",
  "analisis.kpi.duels": "Duelos Ganados",
  "analisis.kpi.duelsSub": "Efectividad global en duelos",
  "analisis.kpi.recLossSubAvg": "Promedio Rec / Pérdidas",
  "analisis.kpi.recLossSubTot": "Total Rec / Pérdidas",
  "analisis.kpi.recoveries": "Recuperaciones / Pérdidas",
  "analisis.kpi.recoveriesSub": "Promedio Rec / Pérdidas",
  "analisis.kpi.recoveriesSubTotal": "Total Rec / Pérdidas",
  "analisis.kpi.shots": "Tiros a Puerta",
  "analisis.kpi.shotsSub": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubAvg": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubTot": "Total Propio vs Rival",
  "analisis.kpi.shotsSubTotal": "Total Propio vs Rival",
  "analisis.loadingData": "Cargando eventos de partidos...",
  "analisis.modal.all": "Todos",
  "analisis.modal.clear": "Limpiar",
  "analisis.modal.confirm": "ACEPTAR Y COMPARAR",
  "analisis.modal.noDate": "Sin fecha",
  "analisis.modal.pending": "Pendiente",
  "analisis.modal.selectedCount": "{count} partidos seleccionados",
  "analisis.modal.title": "Seleccionar Partidos para Comparar",
  "analisis.modal.withData": "Con datos",
  "analisis.mode.averages": "Promedios",
  "analisis.mode.title": "Métricas:",
  "analisis.mode.totals": "Totales",
  "analisis.noMatchesSelected": "Selecciona al menos 1 partido para realizar el análisis comparativo",
  "analisis.selectMatches": "Seleccionar Partidos",
  "analisis.shortcuts.allSeason": "Toda la Temporada",
  "analisis.shortcuts.last3": "Últimos 3",
  "analisis.shortcuts.last5": "Últimos 5",
  "analisis.shortcuts.title": "ATAJOS:",
  "analisis.subtitle": "Evolución táctica, tiros, duelos y recuperaciones a lo largo de la temporada",
  "analisis.table.cards": "Tarjetas (A / R)",
  "analisis.table.duels": "Duelos %",
  "analisis.table.fouls": "Faltas (F / C)",
  "analisis.table.match": "Partido / Rival",
  "analisis.table.recLoss": "Rec / Pérd",
  "analisis.table.result": "Resultado",
  "analisis.table.shots": "Tiros (P / R)",
  "analisis.table.title": "Desglose Detallado por Encuentro",
  "analisis.title": "Análisis Comparativo Multipartido",
  "app.copyright": "2026 Mister11 · {slogan}",
  "app.slogan": "El banquillo en tu bolsillo",
  "attendance.banner.closeMatchSheet": "Cerrar Acta Partido",
  "attendance.banner.completeSession": "📋 Completar Sesión",
  "attendance.banner.unclosedEvents": "Tienes {sessions} sesión{sPlural} sin registrar y {matches} partido{mPlural} con acta abierta.",
  "attendance.banner.unclosedSubtitle": "Completa y cierra para oficializar los % de asistencia y los minutos de los jugadores.",
  "attendance.btn.exportPdf": "📄 Exportar PDF",
  "attendance.callup.activeWindow": "Ventana de Evaluación Activa",
  "attendance.callup.consider": "Valorar",
  "attendance.callup.notRecommended": "No recomendado",
  "attendance.callup.recommended": "Recomendado",
  "attendance.callup.subtitle": "Métricas de asistencia real sobre sesiones programadas para orientar tu próxima convocatoria.",
  "attendance.callup.thBreakdown": "Desglose (P / T / J / A / SR)",
  "attendance.callup.thGuidance": "Orientación",
  "attendance.callup.thPct": "% Ventana",
  "attendance.callup.thPlayer": "Jugador",
  "attendance.callup.thStreak": "🔥 Racha",
  "attendance.callup.title": "🎯 Asistente de Convocatoria por Asistencia",
  "attendance.callup.window.biweekly": "Quincena",
  "attendance.callup.window.microcycle": "Microciclo",
  "attendance.callup.window.season": "Temporada",
  "attendance.callup.window.week": "Semana",
  "attendance.chart.filtersTitle": "Series de la Gráfica y Explicación (Pulsa para Mostrar/Ocultar)",
  "attendance.chart.guide.example": "Actualmente tu equipo promedia un {avg}% de asistencia en los {count} eventos disputados.",
  "attendance.chart.guide.step1": "1. Cada punto es un entreno o partido: ordenados cronológicamente.",
  "attendance.chart.guide.step2": "2. La línea verde es tu asistencia: por encima del 70% vas bien.",
  "attendance.chart.guide.step3": "3. Si la roja sube mientras la verde baja: hay un problema de compromiso a corregir.",
  "attendance.chart.guide.step4": "4. Toca cualquier punto para ver el detalle y abrir su registro.",
  "attendance.chart.guide.title": "¿Cómo interpretar esta gráfica?",
  "attendance.chart.guideCoach": "Guía de Interpretación para el Cuerpo Técnico",
  "attendance.chart.guideStep1": "1. Puntos y Cronología",
  "attendance.chart.guideStep2": "2. Línea Verde",
  "attendance.chart.guideStep3": "3. Cruce de Alerta",
  "attendance.chart.guideStep4": "4. Toca para Detalle",
  "attendance.chart.legend.absent": "Ausentes",
  "attendance.chart.legend.absent.desc": "Faltas sin avisar. Debe tender a cero.",
  "attendance.chart.legend.attendance": "Asistencia Real (P+T)",
  "attendance.chart.legend.attendance.desc": "Jugadores que estuvieron (presentes + tardes). Cuanto más alta, mejor.",
  "attendance.chart.legend.justified": "Justificados",
  "attendance.chart.legend.justified.desc": "Avisos justificados. No castiga el % principal.",
  "attendance.chart.legend.late": "Tardes",
  "attendance.chart.legend.late.desc": "Llegadas tarde. Vigila si sube varias semanas seguidas.",
  "attendance.chart.legend.official": "Oficial (acta o sesión cerrada)",
  "attendance.chart.legend.provisional": "Provisional (acta o sesión abierta)",
  "attendance.chart.legend.threshold70": "Umbral de alerta (70%): por debajo, riesgo de convocatoria.",
  "attendance.chart.noData": "Aún no hay sesiones ni partidos registrados.",
  "attendance.chart.openRegister": "Abrir Registro de Asistencia",
  "attendance.chart.summaryStats": "Resumen del Evento Seleccionado",
  "attendance.chart.title": "Evolución de Asistencia General del Equipo",
  "attendance.markAllPresent": "Marcar Todos Presentes",
  "attendance.register.closingSheet": "Cerrando Acta...",
  "attendance.register.customNew": "+ Nueva Fecha de Asistencia Personalizada",
  "attendance.register.date": "Fecha",
  "attendance.register.excludeTitle": "Excluye esta sesión del cómputo de asistencia de toda la plantilla",
  "attendance.register.expected": "⚽ Se esperan: {attended} de {total}",
  "attendance.register.extraSession": "Sesión Extra",
  "attendance.register.futureSession": "🕐 Sesión futura",
  "attendance.register.markAllPresent": "Marcar Todos Presentes",
  "attendance.register.markSuspended": "Marcar Suspendida",
  "attendance.register.matchSheetClosed": "📋 Acta Oficial Cerrada",
  "attendance.register.matchSheetOpen": "⏳ Acta Abierta",
  "attendance.register.officialNote": "✅ Oficial · confirmado por el míster",
  "attendance.register.officialSaved": "✅ Registro oficial guardado",
  "attendance.register.pendingRegistration": "⏳ Pendiente de registro",
  "attendance.register.prefillRsvp": "⚡ Prellenar desde RSVP",
  "attendance.register.prefillTooltip": "Prellenar desde respuestas del jugador sin pisar ediciones manuales",
  "attendance.register.provisionalNote": "⏳ Provisional · según respuesta del jugador (toca para confirmar)",
  "attendance.register.reopenSheet": "🔓 Reabrir Acta",
  "attendance.register.rsvpLiveTitle": "📲 Respuestas RSVP del Jugador y Planificación (en vivo)",
  "attendance.register.saveAndCloseSheet": "Guardar y Cerrar Acta",
  "attendance.register.saveAttendance": "Guardar Asistencia",
  "attendance.register.selectEvent": "Selecciona Sesión de Entrenamiento o Partido:",
  "attendance.register.sessionsAndMatches": "Sesiones y Partidos",
  "attendance.register.suspendedActive": "Suspendida (Activo)",
  "attendance.register.suspendedSession": "🌧️ Sesión Suspendida",
  "attendance.register.title": "Título",
  "attendance.register.updateNotice": "ℹ️ Puedes corregir el pase de lista; se refleja al instante",
  "attendance.rsvp.going": "Irá",
  "attendance.rsvp.justified": "Justificado",
  "attendance.rsvp.late": "Llegará tarde",
  "attendance.rsvp.none": "Sin respuesta",
  "attendance.rsvp.not_going": "No irá",
  "attendance.saveBtn": "Guardar Asistencia",
  "attendance.saveError": "Error al guardar la asistencia. Inténtalo de nuevo.",
  "attendance.saveSuccess": "Asistencia guardada con éxito.",
  "attendance.saving": "Guardando...",
  "attendance.status.absent": "Ausente",
  "attendance.status.injured": "Lesionado",
  "attendance.status.justified": "Justificado",
  "attendance.status.late": "Retraso",
  "attendance.status.present": "Presente",
  "attendance.status.unmarked": "Sin registrar",
  "attendance.summary.acceptable": "✓ Aceptable",
  "attendance.summary.noData": "⚪ Sin datos",
  "attendance.summary.optimal": "✓ Óptimo",
  "attendance.summary.risk": "⚠️ Riesgo",
  "attendance.summary.sortBy": "Ordenar por:",
  "attendance.summary.sortName": "Nombre",
  "attendance.summary.sortNumber": "Dorsal",
  "attendance.summary.sortPctAsc": "% Asistencia (Menor a Mayor)",
  "attendance.summary.sortPctDesc": "% Asistencia (Mayor a Menor)",
  "attendance.summary.thAbsent": "Ausente",
  "attendance.summary.thAttendance": "% Asistencia",
  "attendance.summary.thInjured": "Lesion.",
  "attendance.summary.thJustified": "Justif.",
  "attendance.summary.thLate": "Tarde",
  "attendance.summary.thNoRecord": "SR",
  "attendance.summary.thPresent": "Presente",
  "attendance.summary.thStatus": "Estado",
  "attendance.summary.threshold": "Umbral Alerta:",
  "attendance.summary.title": "👥 Resumen de Asistencia de la Plantilla ({count} jugadores)",
  "attendance.tab.callup": "🎯 Asistente de Convocatoria",
  "attendance.tab.register": "📋 Registro por Sesión",
  "attendance.tab.summary": "📊 Resumen de Plantilla",
  "attendance.tab.trend": "📈 Evolución / Gráfica",
  "attendance.toast.allMarkedPresent": "Todos marcados como presentes (Oficial)",
  "attendance.toast.errorClosing": "Error al cerrar el acta oficial",
  "attendance.toast.errorReopening": "Error al reabrir el acta",
  "attendance.toast.errorSaving": "Error al guardar la asistencia",
  "attendance.toast.noResponses": "Ningún jugador ha respondido aún",
  "attendance.toast.savedSuccess": "Asistencia guardada con éxito",
  "attendance.toast.selectFirst": "Selecciona primero una sesión o partido",
  "attendance.toast.sheetClosed": "Acta oficial cerrada y minutos calculados",
  "attendance.toast.sheetReopened": "Acta reabierta para edición",
  "attendance.toast.suspendedSaved": "Sesión marcada como suspendida y guardada",
  "auth.coachRole": "Soy Entrenador / Staff",
  "auth.email": "Correo electrónico",
  "auth.forgotPass": "¿Olvidaste tu contraseña?",
  "auth.googleBtn": "Continuar con Google",
  "auth.hasAccount": "¿Ya tienes cuenta?",
  "auth.joinBtn": "Enviar Solicitud",
  "auth.joinTeam": "Unirse a un Equipo",
  "auth.loginBtn": "Entrar a Mister11",
  "auth.loginLink": "Inicia sesión",
  "auth.loginTitle": "Iniciar Sesión",
  "auth.logout": "Cerrar Sesión",
  "auth.noAccount": "¿No tienes cuenta?",
  "auth.parentRole": "Soy Padre / Tutor",
  "auth.password": "Contraseña",
  "auth.playerRole": "Soy Jugador",
  "auth.registerLink": "Regístrate gratis",
  "auth.registerTitle": "Crear Cuenta",
  "auth.switched_coach": "Cambiado a Modo Entrenador",
  "auth.switched_player": "Cambiado a Portal de Jugador",
  "auth.teamCode": "Código de Invitación (6 dígitos)",
  "block.abp": "ABP",
  "block.physical": "Físico",
  "block.tactical": "Táctica",
  "block.technical": "Técnica",
  "block.warmup": "Calent.",
  "board.actions.delete": "LIMPIAR",
  "board.actions.hideRival": "👁 OCULTAR RIVAL",
  "board.actions.showRival": "👁 MOSTRAR RIVAL",
  "board.actions.title": "ACCIONES",
  "board.export.encodingProgress": "Codificando video MP4...",
  "board.export.encodingTitle": "Exportando Video MP4",
  "board.exportModal.btnCancel": "CANCELAR",
  "board.exportModal.btnDownload": "DESCARGAR",
  "board.exportModal.btnExport": "EXPORTAR",
  "board.exportModal.btnReset": "Restablecer encuadre",
  "board.exportModal.btnShare": "COMPARTIR",
  "board.exportModal.closeModal": "Cerrar modal",
  "board.exportModal.completedDesc": "El archivo ha sido procesado y guardado correctamente.",
  "board.exportModal.completedTitle": "¡Exportación Completada!",
  "board.exportModal.exportPath": "Ruta / Destino",
  "board.exportModal.failed": "Error durante la exportación. Pulsa para reintentar.",
  "board.exportModal.format": "Formato de Exportación",
  "board.exportModal.framingTitle": "Encuadre y Previsualización",
  "board.exportModal.landscape": "Horizontal (Landscape)",
  "board.exportModal.loadingPreview": "Cargando encuadre de la animación...",
  "board.exportModal.metaDuration": "Duración estimada",
  "board.exportModal.metaSize": "Tamaño estimado",
  "board.exportModal.metaTitle": "Título del archivo",
  "board.exportModal.oneFrame": "1 Fotograma",
  "board.exportModal.orientation": "Orientación",
  "board.exportModal.portrait": "Vertical (Portrait)",
  "board.exportModal.preparing": "Preparando frames para renderizar...",
  "board.exportModal.quality": "Calidad / Resolución",
  "board.exportModal.shared": "¡Compartido!",
  "board.exportModal.speed": "Velocidad de Reproducción",
  "board.exportModal.subtitle": "Configura los parámetros de exportación y previsualiza el encuadre",
  "board.exportModal.title": "Exportar Animación Táctica",
  "board.exportModal.zoomIn": "Acercar",
  "board.exportModal.zoomOut": "Alejar",
  "board.fields.blank": "Campo en Blanco",
  "board.fields.f7": "Fútbol 7 (65x45m)",
  "board.fields.f8": "Fútbol 8 (62x46m)",
  "board.fields.full": "Campo Completo",
  "board.fields.futsal": "Fútbol Sala (40x20m)",
  "board.fields.halfAttack": "½ Ataque",
  "board.fields.halfDefense": "½ Defensa",
  "board.fields.penaltyArea": "Área Penalti",
  "board.fields.reduced": "Campo Reducido",
  "board.fields.thirdAttack": "1/3 Ofensivo",
  "board.fields.thirdDefense": "1/3 Defensivo",
  "board.fields.thirdMid": "1/3 Medio",
  "board.mat.aro": "Aro de Agilidad",
  "board.mat.balon": "Balón Fútbol",
  "board.mat.balon_movimiento": "Balón en Movimiento",
  "board.mat.balon_negro": "Balón Negro",
  "board.mat.banderin": "Banderín",
  "board.mat.cono": "Cono",
  "board.mat.cono_amarillo": "Cono Amarillo",
  "board.mat.cono_negro": "Cono Negro",
  "board.mat.cono_rojo": "Cono Rojo",
  "board.mat.escalera": "Escalera de Agilidad",
  "board.mat.flecha_ataque_h": "Flecha Ataque Horizontal",
  "board.mat.flecha_ataque_v": "Flecha Ataque Vertical",
  "board.mat.grupo_balones": "Grupo de Balones",
  "board.mat.grupo_conos": "Grupo 3 Conos",
  "board.mat.grupo_conos_arco": "Arco 5 Conos",
  "board.mat.grupo_conos_linea": "Línea 5 Conos",
  "board.mat.indicador_espacio": "Indicador de Espacio",
  "board.mat.jugador_camiseta": "Jugador Camiseta",
  "board.mat.jugador_triangulo": "Jugador Triángulo",
  "board.mat.linea_distancia": "Línea de Distancia",
  "board.mat.mini_cono": "Mini Cono",
  "board.mat.pared_rebote": "Pared de Rebote",
  "board.mat.peto": "Peto de Entrenamiento",
  "board.mat.pica": "Pica / Estaca",
  "board.mat.platillo": "Platillo",
  "board.mat.porteria_grande": "Portería Grande",
  "board.mat.porteria_lateral": "Portería Lateral",
  "board.mat.porteria_pequena": "Portería Pequeña",
  "board.mat.poste": "Poste / Palo",
  "board.mat.valla": "Valla de Salto",
  "board.mat.zona_circular": "Zona Circular",
  "board.mat.zona_grid": "Cuadrícula 3x3",
  "board.mat.zona_rectangular": "Zona Rectangular",
  "board.mat.zona_rombo": "Zona Rombo",
  "board.mat.zona_triangular": "Zona Triangular",
  "board.matCat.balon": "BALONES",
  "board.matCat.coordinacion": "COORDINACIÓN",
  "board.matCat.jugadores": "JUGADORES",
  "board.matCat.material": "MATERIAL",
  "board.matCat.medidas": "MEDIDAS",
  "board.matCat.porteria": "PORTERÍAS",
  "board.matCat.señalizacion": "SEÑALIZACIÓN",
  "board.matCat.zonas": "ZONAS",
  "board.panels.materials": "Material",
  "board.panels.teams": "Equipos",
  "board.panels.teamsAndFormations": "Equipos y Formaciones",
  "board.stroke.fine": "Fino",
  "board.stroke.medium": "Medio",
  "board.stroke.thick": "Grueso",
  "board.teams.apply": "APLICAR",
  "board.teams.local": "Titulares",
  "board.teams.rival": "Rival",
  "board.teams.title": "EQUIPOS",
  "board.teams.wildcard": "Comodín",
  "board.timeline.addFrame": "Añadir fotograma",
  "board.timeline.deleteFrame": "Eliminar fotograma",
  "board.timeline.export": "Exportar",
  "board.timeline.exportAnimation": "Exportar animación",
  "board.timeline.firstFrame": "Primer fotograma",
  "board.timeline.frameLabel": "Fotograma",
  "board.timeline.lastFrame": "Último fotograma",
  "board.timeline.nextFrame": "Siguiente fotograma",
  "board.timeline.play": "Reproducir",
  "board.timeline.playAria": "Reproducir animación",
  "board.timeline.prevFrame": "Fotograma anterior",
  "board.timeline.stop": "Detener",
  "board.timeline.stopAria": "Detener reproducción",
  "board.tool.straight_dashed_line": "Línea recta punteada",
  "board.tool.zone_hexagon": "Zona hexagonal",
  "board.tool.zone_pentagon": "Zona pentagonal",
  "board.toolbar.clearCanvas": "Limpiar todo el canvas",
  "board.toolbar.exportMp4": "EXPORTAR MP4",
  "board.toolbar.exportingMp4": "REC... EXPORTANDO MP4",
  "board.toolbar.fieldType": "Tipo de campo",
  "board.toolbar.fullscreen": "P. Completa",
  "board.toolbar.height": "Alto",
  "board.toolbar.new": "NUEVA",
  "board.toolbar.redo": "Rehacer",
  "board.toolbar.resetZoom": "Reiniciar Zoom",
  "board.toolbar.save": "GUARDAR",
  "board.toolbar.sides": "Lados",
  "board.toolbar.strokeColor": "Color de trazo",
  "board.toolbar.strokeWidth": "Grosor de trazo",
  "board.toolbar.swapSides": "Cambiar lados de equipos",
  "board.toolbar.undo": "Deshacer",
  "board.toolbar.width": "Ancho",
  "board.toolbar.zoomIn": "Acercar",
  "board.toolbar.zoomOut": "Alejar",
  "bottomnav.admin": "Admin",
  "bottomnav.ajustes": "Ajustes",
  "bottomnav.equipo": "Equipo",
  "bottomnav.home": "Inicio",
  "bottomnav.ia": "IA",
  "bottomnav.more": "Más",
  "bottomnav.moreModules": "Módulos y Gestión",
  "bottomnav.partidos": "Partidos",
  "bottomnav.pizarra": "Pizarra",
  "bottomnav.planificacion": "Planificación",
  "bottomnav.sesiones": "Sesiones",
  "bottomnav.tests": "Tests",
  "btn.add": "AÑADIR",
  "btn.back": "VOLVER",
  "btn.cancel": "CANCELAR",
  "btn.close": "CERRAR",
  "btn.confirm": "CONFIRMAR",
  "btn.delete": "ELIMINAR",
  "btn.deleteAccount": "Eliminar Cuenta y Datos (RGPD)",
  "btn.edit": "EDITAR",
  "btn.export": "EXPORTAR PDF",
  "btn.filter": "FILTRAR",
  "btn.save": "GUARDAR",
  "btn.search": "BUSCAR",
  "capture.criteria.downloadPdf": "Descargar PDF Oficial",
  "capture.criteria.search": "Buscar criterio...",
  "capture.criteria.title": "Manual de Criterios de Captura",
  "capture.hud.advanced": "Avanzado",
  "capture.hud.duel_lost": "Duelo Perdido",
  "capture.hud.duel_won": "Duelo Ganado",
  "capture.hud.foul": "Falta",
  "capture.hud.key_pass": "Pase Clave",
  "capture.hud.recovery": "Recuperación",
  "capture.hud.shot": "Tiro",
  "capture.hud.turnover": "Pérdida",
  "capture.hud.unattributed": "Sin atribuir",
  "capture.refine_btn": "Refinar atribución",
  "capture.refine_empty": "Nada pendiente ✅",
  "capture.refine_prompt_title": "¿Refinar atribución individual ahora? (opcional)",
  "capture.refine_skip": "Omitir",
  "capture.refine_subtitle": "Los totales de equipo ya están computados. Asigna solo lo que quieras reflejar en nota, radar y XP.",
  "capture.refine_title": "Refinar atribución individual (opcional)",
  "capture.team.shot_own": "Tiro Propio",
  "capture.team.shot_rival": "Tiro Rival",
  "charts.guide.bars": "Comparativa cuantitativa de las 10 métricas clave de juego.",
  "charts.guide.momentum": "Evolución del dominio y control del partido en bloques de 15 minutos.",
  "charts.guide.radar": "Visualiza el equilibrio táctico en 6 dimensiones entre el equipo propio y el rival.",
  "charts.guide.shots": "Distribución de remates y probabilidad esperada de gol (xG).",
  "charts.guide.zones": "Distribución territorial de las intervenciones del equipo en 9 cuadrantes.",
  "charts.insights.defensive_alert": "Aviso defensivo: El rival generó ocasiones claras con alta comodidad de remate.",
  "charts.insights.dominant_zone": "Zona dominante: Más del 40% de las intervenciones se concentraron en esta zona.",
  "charts.insights.finishing_deficit": "Eficacia rematadora: Volumen alto de ocasiones pero déficit en definición respecto al xG generado.",
  "charts.pass_insufficient_tooltip": "Se requieren al menos 5 pases registrados para generar la red táctica.",
  "charts.view.pass_network": "Red de Pases",
  "charts.view.territorial_map": "Mapa Territorial",
  "chat.notif_from_player": "💬 Mensaje de {playerName}: \"{msgText}\"",
  "club.team_create_error": "Error al crear el equipo del club.",
  "club.team_created": "Equipo del club creado correctamente.",
  "club.teams_assign_error": "Error al asignar equipos.",
  "club.teams_assigned": "Equipos asignados correctamente.",
  "cognitive.active_challenges_title": "Retos y Juegos Recomendados Activos ({count}):",
  "cognitive.assign_error": "Error al guardar las asignaciones",
  "cognitive.assigned_success": "✔ {count} recomendación(es) asignadas con éxito",
  "cognitive.btn_recommend_challenge": "Recomendar Reto",
  "cognitive.btn_verified": "✔ Verificado (+5 XP)",
  "cognitive.btn_verifying": "Verificando…",
  "cognitive.cat.alevin": "Alevín",
  "cognitive.cat.benjamin": "Benjamín",
  "cognitive.cat.cadete": "Cadete",
  "cognitive.cat.infantil": "Infantil",
  "cognitive.cat.juvenil_adulto": "Juvenil / Adulto",
  "cognitive.category_label": "Categoría: {cat}",
  "cognitive.delete_recommendation": "Eliminar recomendación",
  "cognitive.deselect_all": "Desmarcar todos",
  "cognitive.game.decision": "Decisión 1\"",
  "cognitive.game.freno": "Freno",
  "cognitive.game.memoria": "Memoria",
  "cognitive.game.ojo": "Ojo Táctico",
  "cognitive.game.respiracion": "Respiración 4-4",
  "cognitive.game.semaforo": "Semáforo",
  "cognitive.level_by_game_title": "Nivel por Juego (Mérito Adaptativo)",
  "cognitive.metric_avg_accuracy": "Precisión media",
  "cognitive.metric_median_reaction": "Reacción mediana",
  "cognitive.metric_sessions_week": "Sesiones semana",
  "cognitive.metric_trend": "Tendencia",
  "cognitive.modal_assign_title": "⭐ Asignar Retos o Juegos",
  "cognitive.modal_cog_games": "🧠 Juegos Cognitivos ({count}/{total}):",
  "cognitive.modal_confirm_assign": "Confirmar {count} asignación(es)",
  "cognitive.modal_entire_team": "Toda la plantilla del equipo",
  "cognitive.modal_home_retos": "⚽ Retos en Casa ({count}/{total}):",
  "cognitive.modal_only_player": "Solo {name}",
  "cognitive.modal_recipient_label": "Destinatario:",
  "cognitive.modal_select_min": "Selecciona al menos un reto o juego",
  "cognitive.recommendation_deleted": "Recomendación eliminada",
  "cognitive.select_all": "Marcar todos",
  "cognitive.supervision_title": "Supervisión Cognitiva y Retos en Casa",
  "cognitive.target_player": "Individual",
  "cognitive.target_team": "Todo el equipo",
  "cognitive.trend_improving": "↑ En progresión",
  "cognitive.trend_stable": "= Estable",
  "cognitive.verified_xp": "✔ Retos verificados: +5 XP asignados a {name}",
  "cognitive.verify_error": "Error al registrar verificación",
  "cognitive.week_sessions": "Semana actual · {count} sesiones registradas",
  "common.absent": "Ausente",
  "common.all": "TODOS",
  "common.away": "Visitante",
  "common.back": "Volver",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.closeMenu": "Cerrar menú",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.email": "Correo electrónico",
  "common.errorGeneral": "Ocurrió un error inesperado",
  "common.excused": "Justificado",
  "common.friendly": "Amistoso",
  "common.genericError": "Error en la operación",
  "common.home": "Local",
  "common.injured": "Lesionado",
  "common.loading": "Cargando...",
  "common.matchTag": "Partido",
  "common.myTeam": "Mi Equipo",
  "common.no": "No",
  "common.noData": "Sin datos",
  "common.official": "Oficial",
  "common.optimal": "Óptimo",
  "common.originalBadgeEn": "Original EN",
  "common.originalBadgeEs": "Original ES",
  "common.originalLanguage": "Idioma original",
  "common.originalLanguageEn": "Idioma original: Inglés",
  "common.originalLanguageEs": "Idioma original: Español",
  "common.player": "Jugador",
  "common.present": "Presente",
  "common.risk": "Riesgo",
  "common.rival": "Rival",
  "common.save": "Guardar",
  "common.savedSuccess": "Guardado correctamente",
  "common.saving": "Guardando...",
  "common.sessionTag": "Sesión",
  "common.starter": "Titular",
  "common.substitute": "Suplente",
  "common.success": "Operación realizada con éxito",
  "common.training": "Entrenamiento",
  "common.yes": "Sí",
  "consent.authAvatar": "Fotografía o avatar identificativo del jugador en las alineaciones y pizarra",
  "consent.authBiometric": "Ficha antropométrica (altura y peso corporal para el seguimiento físico e IMC)",
  "consent.authDob": "Fecha de nacimiento (Requerido para el cálculo automático de edad y categoría)",
  "consent.authExercises": "Asignación de planes de entrenamiento de recuperación e individuales",
  "consent.authInjuries": "Historial clínico de lesiones sufridas (datos médicos de salud - Art. 9 RGPD)",
  "consent.authName": "Nombre y apellidos (Requerido para la ficha del jugador)",
  "consent.authPhysicalTests": "Resultados de pruebas y tests físicos de aptitud y rendimiento",
  "consent.authPosition": "Posición deportiva y número de dorsal asignado",
  "consent.authPsychosocial": "Cuestionarios psicosociales y tests diarios de bienestar (fatiga, sueño, estrés, humor)",
  "consent.authSessions": "Registros de asistencia y participación en partidos, alineaciones e informes técnicos",
  "consent.clearSig": "Limpiar panel de firma",
  "consent.coachNameLabel": "Primer Entrenador / Responsable",
  "consent.coachNamePlaceholder": "Nombre del Entrenador",
  "consent.detailsTitle": "Detalles del Consentimiento",
  "consent.errBasicAuth": "Es obligatorio autorizar el tratamiento del nombre y fecha de nacimiento para poder registrar al jugador en la aplicación.",
  "consent.errParentDni": "El DNI/NIE/Pasaporte del tutor es obligatorio.",
  "consent.errParentName": "El nombre del padre/madre/tutor es obligatorio.",
  "consent.errPlayerDob": "La fecha de nacimiento del jugador es obligatoria.",
  "consent.errPlayerName": "El nombre del jugador (menor) es obligatorio.",
  "consent.errSig": "Por favor, dibuja tu firma digital en el recuadro antes de continuar.",
  "consent.footerLegal": "Mister11 no almacena tus datos de contacto, la firma ni el archivo PDF en sus bases de datos. El documento PDF se procesa de forma temporal e instantánea en la memoria de tu propio navegador móvil/ordenador. La custodia legal del documento PDF firmado recae enteramente en los padres/tutores y en el entrenador a cargo de la gestión del equipo.",
  "consent.heading": "Consentimiento Parental Digital",
  "consent.instructions": "Cumplimente los datos requeridos. Los campos marcados con (*) son obligatorios.",
  "consent.notifyWhatsapp": "Notificar al Entrenador por WhatsApp",
  "consent.parentDniLabel": "DNI / NIE / Pasaporte *",
  "consent.parentDniPlaceholder": "Ej. 12345678Z",
  "consent.parentNameLabel": "Nombre del Tutor *",
  "consent.parentNamePlaceholder": "Nombre y Apellidos",
  "consent.parentPhoneLabel": "Teléfono de Contacto",
  "consent.parentPhonePlaceholder": "Ej. +34 600 000 000",
  "consent.playerDobLabel": "Fecha de Nacimiento *",
  "consent.playerNameLabel": "Nombre del Jugador *",
  "consent.playerNamePlaceholder": "Nombre y Apellidos",
  "consent.privacyDesc": "Este documento ha sido generado de manera local. Mister11 no almacena copias de tu firma ni del consentimiento en sus servidores. Envía el PDF descargado al entrenador por WhatsApp para que lo conserve de forma segura.",
  "consent.privacyTitle": "AVISO DE PRIVACIDAD",
  "consent.redownloadPdf": "Volver a descargar PDF",
  "consent.relationFather": "Padre",
  "consent.relationGuardian": "Tutor Legal / Representante",
  "consent.relationLabel": "Parentesco *",
  "consent.relationMother": "Madre",
  "consent.seasonLabel": "Temporada",
  "consent.sec1": "1. Datos del Padre, Madre o Tutor",
  "consent.sec2": "2. Datos del Jugador Menor",
  "consent.sec3": "3. Datos del Equipo y Entrenador",
  "consent.sec4": "4. Autorizaciones de Datos Personales",
  "consent.sec4Desc": "Seleccione qué datos autoriza que sean procesados en Mister11 por el cuerpo técnico:",
  "consent.sec5": "5. Declaración de Consentimiento Expreso",
  "consent.sec5Text": "Por la presente, actuando en calidad de padre, madre o tutor legal del menor arriba indicado, declaro que he sido informado de forma transparente sobre la finalidad y el tratamiento de los datos deportivos y de bienestar del jugador en la plataforma Mister11. Otorgo mi consentimiento expreso para el tratamiento de las casillas marcadas anteriormente.",
  "consent.sec6": "6. Firma Digital del Tutor",
  "consent.sigLabel": "Dibuja tu Firma con el Dedo o Ratón *",
  "consent.subTitle": "Autorización informada para la gestión deportiva del jugador menor de edad.",
  "consent.submitBtn": "Firmar y Generar Documento PDF",
  "consent.submittingBtn": "Generando PDF firmado...",
  "consent.successDesc": "El documento de consentimiento parental para el jugador {name} se ha generado y descargado en tu dispositivo correctamente.",
  "consent.successTitle": "¡Firmado con Éxito!",
  "consent.teamNameLabel": "Equipo / Club",
  "consent.teamNamePlaceholder": "Nombre del Equipo",
  "consent.whatsappMsg": "Hola entrenador, ya he rellenado y firmado digitalmente el consentimiento parental para {name}. He descargado el PDF firmado en mi dispositivo. Te lo comparto a continuación.",
  "convocation.allRecipientsSelected": "Todos seleccionados",
  "convocation.cleanSelection": "Limpiar selección",
  "convocation.coachLabel": "ENTRENADOR / COACH",
  "convocation.competition": "Competición",
  "convocation.counter": "{count}/18 seleccionados",
  "convocation.defaultMessage": "Convocatoria para el partido vs {opponent}. Revisad los detalles.",
  "convocation.download": "Descargar PNG",
  "convocation.downloading": "Descargando...",
  "convocation.generate": "Generar convocatoria PNG",
  "convocation.generatedWith": "Generado con Mister11",
  "convocation.generating": "Generando PNG...",
  "convocation.limitReached": "Límite alcanzado: máximo 18 jugadores convocados",
  "convocation.matchInfo.convocationTime": "Hora convocatoria (-1h)",
  "convocation.matchInfo.date": "Fecha",
  "convocation.matchInfo.location": "Lugar",
  "convocation.matchInfo.matchTime": "Hora del partido",
  "convocation.matchInfo.rival": "Rival",
  "convocation.message": "Mensaje de comunicado",
  "convocation.missingPlayersWarning": "Se recomiendan 18 jugadores para la convocatoria completa.",
  "convocation.noMatchSelected": "No hay partido próximo programado.",
  "convocation.noPlayersSelected": "No has seleccionado ningún jugador.",
  "convocation.positions.def": "DEFENSAS",
  "convocation.positions.fwd": "DELANTEROS",
  "convocation.positions.gk": "PORTEROS",
  "convocation.positions.mid": "MEDIOCAMPISTAS",
  "convocation.positionsEn.def": "DEFENDERS",
  "convocation.positionsEn.fwd": "FORWARDS",
  "convocation.positionsEn.gk": "GOALKEEPERS",
  "convocation.positionsEn.mid": "MIDFIELDERS",
  "convocation.previewTitle": "Previsualización de Convocatoria",
  "convocation.quickAccess": "Convocatoria del próximo partido",
  "convocation.regenerate": "Regenerar / Editar",
  "convocation.round": "Jornada",
  "convocation.selectPlayers": "Selecciona los convocados",
  "convocation.send": "Enviar",
  "convocation.sendError": "Error al enviar la convocatoria.",
  "convocation.sendModalTitle": "Enviar Convocatoria a Jugadores",
  "convocation.sendSuccess": "Convocatoria enviada a los jugadores correctamente.",
  "convocation.sendToPlayers": "Enviar a jugadores",
  "convocation.sending": "Enviando...",
  "convocation.tab": "Convocatoria",
  "convocation.title": "Convocatoria",
  "csv.browseFile": "Seleccionar Archivo",
  "csv.confirmImport": "Confirmar e Importar Jugadores",
  "csv.continueToPreview": "Continuar a Vista Previa",
  "csv.downloadTemplate": "Descargar Plantilla CSV",
  "csv.dropzoneDesc": "Archivos compatibles: .csv, .xlsx, .xls (máx. 5MB)",
  "csv.dropzoneTitle": "Arrastra tu archivo aquí o haz clic para seleccionarlo",
  "csv.errorDuplicateNumberFile": "Dorsal duplicado dentro del archivo.",
  "csv.errorDuplicateNumberTeam": "El dorsal ya está ocupado en el equipo.",
  "csv.errorEmptyFile": "El archivo seleccionado está vacío.",
  "csv.errorInvalidNumber": "El dorsal debe ser un número entero entre 1 y 99.",
  "csv.errorInvalidPosition": "Posición no válida. Usa POR, DEF, MC, DEL o equivalente.",
  "csv.errorMissingName": "El nombre del jugador es obligatorio.",
  "csv.errorParsing": "No se pudo leer el archivo. Comprueba el formato CSV o Excel.",
  "csv.errorPlanLimitExceeded": "Has alcanzado el límite de jugadores permitido por tu plan.",
  "csv.errorUnsupportedFormat": "Formato no soportado. Usa archivos .csv o .xlsx.",
  "csv.fieldBirthDate": "Fecha de Nacimiento",
  "csv.fieldDorsal": "Dorsal / Número",
  "csv.fieldEmail": "Correo Electrónico",
  "csv.fieldOptional": "Opcional",
  "csv.fieldPlayerName": "Nombre del Jugador",
  "csv.fieldPosition": "Posición Principal",
  "csv.fieldRequired": "Requerido",
  "csv.importErrorToast": "Ocurrió un error al importar los jugadores.",
  "csv.importSuccessToast": "Se han importado {count} jugadores con éxito.",
  "csv.mappingIntro": "Asigna las columnas de tu archivo a los campos de Mister11:",
  "csv.modalTitle": "Importar Jugadores vía CSV / Excel",
  "csv.selectColumn": "Seleccionar columna...",
  "csv.status": "Estado",
  "csv.stepMapping": "Mapeo",
  "csv.stepPreview": "Vista Previa",
  "csv.stepUpload": "Subir",
  "csv.summaryErrors": "Filas con errores a corregir:",
  "csv.summaryReady": "Jugadores listos para importar:",
  "csv.tagValid": "Válido",
  "csv.templateSubtitle": "Descarga nuestra plantilla oficial con columnas predefinidas.",
  "csv.templateTitle": "¿No tienes una plantilla?",
  "dashboard.activity": "Esta es la actividad de tu equipo ({club}) para esta semana.",
  "dashboard.devAccess": "Acceso de Desarrollador - Mister11 PRO",
  "dashboard.devDesc": "Tu cuenta tiene acceso permanente de por vida con todos los límites removidos.",
  "dashboard.devUnlimited": "✔ DESARROLLADOR ILIMITADO",
  "dashboard.estimatedWorkload": "Carga de Trabajo Estimada",
  "dashboard.joinAsStaff": "Unirse a un equipo como Staff",
  "dashboard.noUpcomingSessions": "No hay sesiones próximas.",
  "dashboard.period.macro": "Este macrociclo",
  "dashboard.period.meso": "Este mesociclo",
  "dashboard.period.micro": "Este microciclo",
  "dashboard.period.session": "Esta sesión",
  "dashboard.period.week": "Esta semana",
  "dashboard.quickAccess": "Acceso Rápido",
  "dashboard.saveDashboard": "GUARDAR DASHBOARD",
  "dashboard.stats.matches": "Partidos",
  "dashboard.stats.noRival": "Sin rival",
  "dashboard.stats.players": "Jugadores",
  "dashboard.stats.rival": "Próximo Rival",
  "dashboard.stats.sessions": "Sesiones",
  "dashboard.teamWorkloadIndex": "Índice de Carga del Equipo",
  "dashboard.today": "Hoy",
  "dashboard.upcomingSessions": "Próximas Sesiones",
  "dashboard.upgrade.activatePro": "Activar Modo PRO",
  "dashboard.upgrade.activateProTrial": "Activar Prueba PRO",
  "dashboard.upgrade.freePlanDesc": "Límites activos: 1 equipo, 23 jugadores, 10 sesiones y 5 generaciones de IA al mes.",
  "dashboard.upgrade.freePlanTitle": "⭐ Mister11 Plan Gratuito (Limitado)",
  "dashboard.upgrade.planActiveDesc": "Tienes acceso completo a todas las funciones. Gracias por ser parte de Mister11 PRO.",
  "dashboard.upgrade.planActiveTitle": "👑 Mister11 {plan} · Plan Activo",
  "dashboard.upgrade.renewAccess": "🔓 RENOVAR ACCESO",
  "dashboard.upgrade.resetTrial": "Reiniciar",
  "dashboard.upgrade.subscribe": "⚡ SUSCRIBIRME",
  "dashboard.upgrade.trialActiveDesc": "Tienes acceso total a todas las funciones premium. Te quedan {days} días ({hours}h) de prueba.",
  "dashboard.upgrade.trialActiveTitle": "👑 Mister11 {plan} · Prueba Gratuita Activa",
  "dashboard.upgrade.trialExpiredDesc": "🔒 Tu prueba gratuita ha finalizado. Suscríbete para recuperar el acceso PRO.",
  "dashboard.upgrade.trialExpiringDesc": "Solo quedan {hours} de prueba. Suscríbete para no perder el acceso.",
  "dashboard.upgrade.trialExpiringTitle": "⚠️ ¡Tu prueba vence pronto!",
  "dashboard.upgrade.tryFree": "Probar Plan Gratuito",
  "dashboard.upgrade.viewPlans": "Ver Planes PRO",
  "dashboard.upgrade.viewPlansPro": "👑 VER PLANES PRO",
  "dashboard.viewAll": "Ver todas",
  "dashboard.weeklyReport.desc": "Resumen de entrenamientos y partidos de la semana ({sessions} sesiones, {matches} partidos).",
  "dashboard.weeklyReport.download": "Descargar PDF",
  "dashboard.weeklyReport.ready": "¡Tu Informe Semanal está listo!",
  "dashboard.welcome": "Hola, {name}",
  "dashboard.workload.week": "Sem",
  "day.Dom": "Dom",
  "day.Jue": "Jue",
  "day.Lun": "Lun",
  "day.Mar": "Mar",
  "day.Mié": "Mié",
  "day.Sáb": "Sáb",
  "day.Vie": "Vie",
  "download.cache_hint": "Guardado en caché. Si no se abre, busca \"{filename}\" en Archivos",
  "download.csv_success": "✅ Plantilla exportada exitosamente.",
  "download.generic_error": "Error al exportar alineación",
  "download.image_success": "✅ Imagen exportada exitosamente.",
  "download.json_success": "✅ Archivo exportado exitosamente.",
  "download.lineup_downloading": "⬇️ Descargando alineación: {filename}",
  "download.lineup_saved": "✅ Alineación guardada en {path}",
  "download.lineup_share_dialog": "Guardar o compartir alineación...",
  "download.lineup_share_title": "Mister11 — Alineación {team}",
  "download.pdf_error": "Error al guardar el PDF",
  "download.pdf_ready": "✅ PDF listo: \"{filename}\"",
  "download.save_error_share_fallback": "⚠️ No se pudo guardar automáticamente; usa Compartir.",
  "download.saved_in": "✅ Guardado en: {path}",
  "download.video_success": "✅ Animación exportada exitosamente.",
  "equipo.loadingSquad": "Cargando plantilla...",
  "equipo.publishAnnouncement": "Publicar Comunicado",
  "equipo.tab.attendance": "Control de Asistencia",
  "equipo.tab.squad": "Plantilla",
  "equipo.tab.staff": "Cuerpo Técnico",
  "equipo.title": "Gestión del Equipo",
  "error.retry_section": "Reintentar",
  "error.section_code": "Código: {code}",
  "error.section_desc": "Ha ocurrido una anomalía aislada al renderizar esta sección. El resto del partido continúa operativo.",
  "error.section_unavailable": "Sección no disponible temporalmente",
  "errors.codeAlreadyUsed": "Este código ya fue utilizado.",
  "errors.codeExpired": "Esta invitación ha expirado.",
  "errors.codeInvalid": "Código no válido. Debe tener 6 caracteres.",
  "errors.codeNotFound": "Equipo no encontrado. Verifica el código o contacta al entrenador.",
  "exerciseCatalog.categories.cooldown": "Vuelta a la calma",
  "exerciseCatalog.categories.main": "Parte Principal",
  "exerciseCatalog.categories.warmup": "Calentamiento",
  "exerciseCatalog.clinicalFallbackNotice": "Fuente oficial en verificación",
  "exerciseCatalog.phases.fase1": "Fase 1: Carrera y Calentamiento Dinámico",
  "exerciseCatalog.phases.fase2": "Fase 2: Fuerza, Pliometría y Equilibrio",
  "exerciseCatalog.phases.fase3": "Fase 3: Carrera a Alta Velocidad y Cambios de Dirección",
  "exerciseCatalog.sourceLabel": "Fuente",
  "exports.gk.claims": "Salidas / Rechaces",
  "exports.gk.cleanSheets": "Porterías a Cero",
  "exports.gk.conceded": "Encajados",
  "exports.gk.errors": "Errores",
  "exports.gk.goalkeeper": "Portero",
  "exports.gk.penaltySaves": "Pen. Parados",
  "exports.gk.rating": "Nota GK",
  "exports.gk.savePct": "% Eficacia",
  "exports.gk.saves": "Paradas",
  "exports.gk.title": "RENDIMIENTO DE PORTERÍA",
  "exports.report.match_info": "Ficha del Partido",
  "exports.report.page": "Página",
  "exports.report.sec10_players": "10. Rendimiento Individual y Plantilla",
  "exports.report.sec11_swot": "11. Análisis DAFO Táctico y Recomendaciones",
  "exports.report.sec1_lineup": "1. Alineación Táctica con Fotografías",
  "exports.report.sec2_timeline": "2. Marcador y Cronología de Eventos",
  "exports.report.sec3_momentum": "3. Momentum y Posesión por Bloques 15'",
  "exports.report.sec4_bars": "4. Barras Comparativas (10 Métricas)",
  "exports.report.sec5_radar": "5. Radar Comparativo Propio vs Rival",
  "exports.report.sec6_top5": "6. Métricas Top-5 Diferenciales",
  "exports.report.sec7_shots": "7. Mapas de Tiros y Modelo xG-Lite",
  "exports.report.sec8_tactics": "8. Campo y Táctica (Pasillos, ABP y Territorio)",
  "exports.report.sec9_gk": "9. Exigencia y Rendimiento de Portería",
  "exports.report.sec_photos": "Fotografías y Capturas del Encuentro",
  "exports.report.tactical_analysis": "Análisis Táctico",
  "exports.report.title": "INFORME OFICIAL POST-PARTIDO",
  "exports.test.attendance": "Asistencia",
  "exports.test.mental": "Test Mental / Psicosocial",
  "exports.test.physical": "Test Físico",
  "exports.test.radar_title": "Perfil Integral de Rendimiento",
  "exports.test.recommendation_title": "Recomendaciones Individuales",
  "exports.test.table_interp": "Interpretación",
  "exports.test.table_score": "Puntuación",
  "exports.test.table_test": "Test",
  "exports.test.tactical": "Test Táctico",
  "exports.test.technical": "Test Técnico",
  "exports.test.title": "INFORME DE EVALUACIÓN Y TESTS",
  "form.teamName": "Nombre del Equipo",
  "games.assignment.todayPrompt": "El cuerpo técnico te ha asignado un reto especial",
  "games.badge.recommended": "Recomendado por tu míster",
  "games.best.accuracy": "Precisión: {val}%",
  "games.best.hits": "Aciertos: {val}/5",
  "games.best.maxCones": "Máx: {val} conos",
  "games.best.record": "Récord: {val} ms",
  "games.btn.backToCatalog": "Volver al Catálogo",
  "games.btn.play": "Jugar",
  "games.btn.practiceFirst": "Probar en Modo Práctica",
  "games.btn.startOfficial": "Comenzar Sesión",
  "games.btn.startReto": "Entrenar",
  "games.disclaimer": "Entrenamiento cognitivo de apoyo, no es terapia; en TDAH seguir pautas de especialistas.",
  "games.finish.healthyClosing": "¡Gran trabajo mental! Descansa la vista y el cuerpo.",
  "games.finish.subtitle": "Has completado la sesión con dedicación.",
  "games.finish.title": "¡Excelente esfuerzo!",
  "games.g1.falseStart": "🚫 Salida en falso.",
  "games.g1.skill": "Velocidad de reacción",
  "games.g1.statBest": "Mejor marca",
  "games.g1.statFalses": "Salidas falso",
  "games.g1.statMedian": "Mediana",
  "games.g1.step1": "Espera en rojo.",
  "games.g1.step2": "Toca la pantalla al ponerse VERDE.",
  "games.g1.step3": "Tocar antes = salida en falso.",
  "games.g1.tapAreaPrompt": "Toca aquí al ponerse en VERDE",
  "games.g1.tapNow": "¡PULSA AHORA!",
  "games.g1.title": "Semáforo Pro",
  "games.g1.tooSlow": "¡Muy lento! Fallo.",
  "games.g1.waitGreen": "Espera al verde…",
  "games.g1.what": "Reaccionar en milisegundos: salir al balón antes que el rival.",
  "games.g1.why": "Llegar 0,2 s antes a un balón dividido cambia la jugada. La reacción se entrena y se transfiere a salidas e interceptaciones.",
  "games.g2.crMsg": "🛑 ¡Freno perfecto!",
  "games.g2.faMsg": "🚫 Era rojo: había que frenar.",
  "games.g2.missMsg": "⏱️ Se te escapó el verde.",
  "games.g2.prepare": "Atento al cono…",
  "games.g2.skill": "Autocontrol y decisión",
  "games.g2.statAcc": "Precisión",
  "games.g2.statFa": "Frenadas fallidas",
  "games.g2.statRt": "Tiempo medio",
  "games.g2.step1": "Aparece un cono en una de las casillas.",
  "games.g2.step2": "VERDE → tócalo rápido.",
  "games.g2.step3": "ROJO → NO lo toques, frena tu dedo.",
  "games.g2.title": "Freno Impulsivo",
  "games.g2.what": "Frenar el impulso: decidir antes de actuar.",
  "games.g2.why": "La mayoría de errores vienen de actuar deprisa. El \"freno\" mejora el regate, evita faltas y ayuda a jugadores con TDAH.",
  "games.g3.hitMsg": "✅ ¡Libre encontrado!",
  "games.g3.markedMsg": "❌ Ese estaba marcado. Mira el despejado.",
  "games.g3.practiceGuide": "El compañero libre brilla en oro. ¡Tócalo!",
  "games.g3.rivalMsg": "😉 Ese es un rival. Busca al compañero.",
  "games.g3.scanPrompt": "Busca con la mirada…",
  "games.g3.skill": "Escaneo visual y percepción",
  "games.g3.statHits": "Aciertos",
  "games.g3.statRounds": "Rondas",
  "games.g3.statTime": "Tiempo medio",
  "games.g3.step1": "🟢 compañeros · 🔴 rivales.",
  "games.g3.step2": "Toca al compañero con MÁS espacio libre.",
  "games.g3.step3": "5 segundos por ronda.",
  "games.g3.timeOut": "⏱️ Tiempo. El libre era el más despejado.",
  "games.g3.title": "Ojo Táctico",
  "games.g3.what": "Ver el juego: encontrar al compañero libre antes de recibir.",
  "games.g3.why": "Los profesionales escanean 6-8 veces cada 10 s. Ver al libre antes de recibir convierte una buena decisión en un buen pase.",
  "games.g4.correctMsg": "✅ ¡Secuencia perfecta!",
  "games.g4.missMsg": "❌ Casi. Sigue intentando.",
  "games.g4.repeat": "¡Repite la secuencia!",
  "games.g4.skill": "Memoria de trabajo",
  "games.g4.statMax": "Máx. secuencia",
  "games.g4.statOk": "Rondas acertadas",
  "games.g4.statRange": "Rango",
  "games.g4.step1": "Observa el orden en que se iluminan los conos.",
  "games.g4.step2": "Repite la secuencia tocando los mismos conos.",
  "games.g4.step3": "Cada ronda la secuencia es más larga.",
  "games.g4.title": "Memoria de Conos",
  "games.g4.watch": "Observa con atención…",
  "games.g4.what": "Recordar información bajo presión.",
  "games.g4.why": "Recordar consignas y movimientos mejora la atención y la comprensión táctica: la \"pizarra mental\" del jugador.",
  "games.g5.cycleHeader": "Ciclo {current} de {total}",
  "games.g5.exhale": "Exhala",
  "games.g5.exhaleTip": "Suelta el aire suavemente por la boca",
  "games.g5.inhale": "Inhala",
  "games.g5.inhaleTip": "Inhala despacio por la nariz llenando el abdomen",
  "games.g5.skill": "Calma y autocontrol",
  "games.g5.statBenefit": "Beneficio",
  "games.g5.statCycles": "Ciclos",
  "games.g5.statTempo": "Compás",
  "games.g5.step1": "El círculo crece → inhala suavemente por la nariz (4 s).",
  "games.g5.step2": "El círculo encoge → exhala despacio por la boca (4 s).",
  "games.g5.step3": "6 ciclos completos, sin prisas ni puntuación.",
  "games.g5.title": "Respiración 4-4",
  "games.g5.what": "Calmar los nervios antes de jugar.",
  "games.g5.why": "La respiración cuadrada 4-4 activa el sistema parasimpático: baja pulso y ansiedad en ~1 min. La usan deportistas de élite; es simple y se hace en cualquier sitio. Por eso la elegimos.",
  "games.g5.zenBadge": "6 ciclos de calma",
  "games.g6.clueGoal": "Portería:",
  "games.g6.clueMate": "Compañero:",
  "games.g6.clueSpace": "Espacio libre:",
  "games.g6.optDribble": "CONDUCCIÓN",
  "games.g6.optPass": "PASE",
  "games.g6.optShoot": "TIRO",
  "games.g6.prompt": "¡Decide rápido!",
  "games.g6.skill": "Lectura táctica",
  "games.g6.statAcc": "Aciertos",
  "games.g6.statPct": "Precisión",
  "games.g6.statTime": "Tiempo medio",
  "games.g6.step1": "Lee las 3 pistas en pantalla.",
  "games.g6.step2": "Portería LIBRE → TIRO.",
  "games.g6.step3": "Si no, compañero LIBRE → PASE. Si no → CONDUCCIÓN (4 s por turno).",
  "games.g6.timeOutMsg": "⏱️ Tiempo. La mejor opción era {option}.",
  "games.g6.title": "Decisión 1 Segundo",
  "games.g6.what": "Elegir la mejor acción en un vistazo: pase, tiro o conducción.",
  "games.g6.why": "El fútbol se juega con la cabeza: decidir rápido y bien marca la diferencia entre un jugador bueno y uno excelente.",
  "games.honesty.pact": "Pacto de honestidad: anota tus repeticiones reales. ¡El esfuerzo es tuyo!",
  "games.intro.howTitle": "Cómo se juega",
  "games.intro.whatTitle": "Qué entrenamos",
  "games.intro.whyTitle": "Por qué te ayuda en el campo",
  "games.legend_ceiling": "👑 ¡Alcanzaste el techo de Leyenda! ¡Eres un crack!",
  "games.level_up": "🎉 ¡Subiste a nivel {level}! {badge} (+10 XP)",
  "games.limits.available": "Disponible",
  "games.limits.cognitiveLbl": "Juegos Cognitivos",
  "games.limits.cognitiveLockedDesc": "Has alcanzado el límite saludable de 15 minutos de juegos cognitivos. ¡A descansar la mente para consolidar lo aprendido!",
  "games.limits.cognitiveLockedTitle": "🧠 ¡Mente entrenada por hoy!",
  "games.limits.completed": "Completado",
  "games.limits.completedToday": "Completado por hoy",
  "games.limits.lockedDesc": "Has alcanzado el límite saludable de entrenamiento diario. Vuelve mañana para seguir mejorando.",
  "games.limits.lockedTitle": "¡Bien hecho por hoy!",
  "games.limits.minutesLbl": "Tiempo jugado",
  "games.limits.remainingMin": "Te quedan {count} min hoy",
  "games.limits.remainingTime": "Te quedan {time} hoy",
  "games.limits.retosLbl": "Retos en Casa",
  "games.limits.retosLockedDesc": "Has alcanzado tus 20 minutos de retos en casa por hoy. ¡Gran esfuerzo físico, recupérate para el próximo entreno!",
  "games.limits.retosLockedTitle": "⚽ ¡Cuerpo y técnica trabajados!",
  "games.limits.sessionsLbl": "Sesiones hoy",
  "games.limits.title": "Entrenamiento Saludable",
  "games.ranking.empty": "Comienza tus entrenamientos para inaugurar el podio de la semana.",
  "games.ranking.resetInfo": "Reset cada lunes",
  "games.ranking.subtitle": "Un espacio de superación sana donde premiamos la constancia y el progreso personal, no la rivalidad.",
  "games.ranking.tabImproved": "Más Mejorado",
  "games.ranking.tabPoints": "Puntos Semanales",
  "games.ranking.title": "Ranking Semanal Saludable",
  "games.retos.addRep": "+1 Repetición",
  "games.retos.attemptsExhausted": "Límite de 2 intentos por hoy alcanzado. ¡Descansa y vuelve mañana!",
  "games.retos.attemptsToday": "intentos hoy",
  "games.retos.btnStart": "Iniciar Reto",
  "games.retos.btnSuperado": "Completado hoy",
  "games.retos.completedBadge": "Superado hoy",
  "games.retos.completedResult": "Completado",
  "games.retos.crp.metric": "Mejor racha",
  "games.retos.crp.skill": "Coordinación",
  "games.retos.crp.title": "Cabeza-Rodilla-Pie",
  "games.retos.crp.what": "Coordinación cabeza-rodilla-pie.",
  "games.retos.cuerda.metric": "Saltos totales",
  "games.retos.cuerda.skill": "Coordinación y resistencia",
  "games.retos.cuerda.title": "Salta la Cuerda",
  "games.retos.cuerda.what": "Coordinación de pies y resistencia.",
  "games.retos.dom.metric": "Mejor racha",
  "games.retos.dom.skill": "Toque y control",
  "games.retos.dom.title": "Dominadas de Balón",
  "games.retos.dom.what": "Toque y control del balón.",
  "games.retos.eq.metric": "Sets superados",
  "games.retos.eq.skill": "Propiocepción",
  "games.retos.eq.title": "Reto Equilibrio",
  "games.retos.eq.what": "Equilibrio y estabilidad de tobillo.",
  "games.retos.esc.metric": "Sets superados",
  "games.retos.esc.skill": "Frecuencia de pies",
  "games.retos.esc.title": "Escalera de Coordinación",
  "games.retos.esc.what": "Apoyos rápidos y frecuencia motriz.",
  "games.retos.finishSet": "Terminar Set ✔",
  "games.retos.lockedBtn": "Bloqueado por hoy",
  "games.retos.pared.metric": "Pases totales",
  "games.retos.pared.skill": "Pase y pie malo",
  "games.retos.pared.title": "Pared de Pases",
  "games.retos.pared.what": "Pase preciso y pie no dominante.",
  "games.retos.punt.metric": "Aciertos totales",
  "games.retos.punt.skill": "Precisión de pase",
  "games.retos.punt.title": "Puntería al Cono",
  "games.retos.punt.what": "Precisión de pase a distancia.",
  "games.retos.questionTimer": "¿Lograste mantener el ejercicio durante todo el tiempo?",
  "games.retos.recommendedBadge": "Asignado",
  "games.retos.reg.metric": "Sets superados",
  "games.retos.reg.skill": "Conducción",
  "games.retos.reg.title": "Slalom de Regates",
  "games.retos.reg.what": "Conducción con obstáculos y cambio de ritmo.",
  "games.retos.repetitions": "{count} repeticiones",
  "games.retos.setHeader": "Set {current} de {total}",
  "games.retos.setsWord": "sets",
  "games.retos.startTimer": "Comenzar Tiempo",
  "games.retos.statSets": "Sets",
  "games.retos.statStatus": "Resultado",
  "games.retos.streakEnd": "Se cayó / Fin de racha",
  "games.retos.timeExhausted": "Has alcanzado el límite de 20 min de retos hoy. ¡Gran esfuerzo físico!",
  "games.retos.touchesStreak": "{count} toques seguidos",
  "games.safety.title": "Seguridad en casa",
  "games.status.notPlayed": "Sin registro",
  "games.status.practice": "Práctica (no puntúa)",
  "games.tabs.cognitive": "Juegos Cognitivos (6)",
  "games.tabs.retos": "Retos en Casa (8)",
  "games.timer.paused": "Pausado",
  "games.timer.remainingChip": "Restante hoy: {time}",
  "games.timer.setFinishing": "Último set",
  "gk.activeGoalkeeper": "PORTERO EN CAMPO",
  "gk.aerialClaim": "Saídas Aéreas",
  "gk.boxDominance": "Domínio de Área",
  "gk.btn.claim": "Salida / Rechace",
  "gk.btn.conceded": "Gol Encajado",
  "gk.btn.errorGoal": "Error de Gol",
  "gk.btn.penaltySave": "Penalti Parado",
  "gk.btn.save": "Parada",
  "gk.buildup": "Saída de Bola / Construção",
  "gk.claims": "Salidas y Despejes",
  "gk.claimsShort": "Salidas",
  "gk.cleanSheets": "Porterías a Cero",
  "gk.cleanSheetsShort": "Invicto",
  "gk.conceded": "Goles Encajados",
  "gk.concededShort": "Enc.",
  "gk.diveLow": "Queda Rasteira",
  "gk.errorGoal": "Errores de Gol",
  "gk.errorGoalShort": "Err. Gol",
  "gk.events.empty": "Sin intervenciones registradas para este partido.",
  "gk.events.list": "Eventos de Portería",
  "gk.evolution": "Evolución del % de Paradas",
  "gk.history": "Historial de Partidos",
  "gk.noActiveGoalkeeper": "Sin portero activo en campo",
  "gk.parrySafe": "Espalmada Segura",
  "gk.penaltySaves": "Penaltis Parados",
  "gk.penaltySavesShort": "Pen. Par.",
  "gk.perMatch": "Por partido",
  "gk.rating": "Nota de Portero",
  "gk.reflexClose": "Reflexos à Queima-Roupa",
  "gk.role": "Portero",
  "gk.roleBadge": "🧤 Portero",
  "gk.saveHigh": "Defesa no Alto",
  "gk.savePercentage": "% Paradas",
  "gk.savePercentageShort": "% Paradas",
  "gk.saves": "Paradas",
  "gk.savesShort": "Par.",
  "gk.smother": "Dividida no Chão",
  "gk.suggest.confirm": "Sí, asignar al portero",
  "gk.suggest.ignore": "No, solo registrar gol",
  "gk.suggest.message": "Se ha registrado un gol rival. ¿Deseas sumar 1 gol encajado al portero en campo ({name})?",
  "gk.suggest.title": "¿Asignar gol encajado?",
  "gk.sweeper": "Goleiro Líbero",
  "gk.title": "Métricas de Portero",
  "gk.tooltip.claim": "Salida aérea, interceptación o despeje de puños.",
  "gk.tooltip.cleanSheet": "Partido completado con minutos jugados sin encajar gol.",
  "gk.tooltip.conceded": "Gol recibido mientras estuvo en la portería.",
  "gk.tooltip.errorGoal": "Fallo directo en posesión o salida que desemboca en gol rival.",
  "gk.tooltip.penaltySave": "Pena máxima detenida durante el encuentro.",
  "gk.tooltip.save": "Intervención exitosa que evita un gol rival.",
  "header.logoutConfirm": "¿Deseas cerrar sesión o cambiar de cuenta?",
  "header.switchPlayerPortal": "Cambiar a Portal Jugador",
  "health.active": "Activo",
  "health.addInjury": "+ Registrar Lesión",
  "health.additionalNotes": "Notas Adicionales",
  "health.affectedArea": "Zona Afectada *",
  "health.cancel": "Cancelar",
  "health.injuryDate": "Fecha de Lesión *",
  "health.injuryType": "Tipo de Lesión *",
  "health.markRecovered": "Marcar como Recuperado",
  "health.medicalNotes": "Observaciones Médicas",
  "health.medicalNotesPlaceholder": "Alergias, tratamientos continuos, notas médicas...",
  "health.noInjuries": "Sin lesiones registradas.",
  "health.recordInjury": "Registrar Nueva Lesión",
  "health.resolved": "Recuperado",
  "health.saveInjury": "Guardar Lesión",
  "health.status.active": "Disponible / Activo",
  "health.status.current": "Estado Actual",
  "health.status.injured": "Lesionado",
  "health.status.recovery": "En Recuperación",
  "health.status.rest": "Descanso",
  "health.title": "Historial Médico y Lesiones",
  "health.updateStatus": "Actualizar Estado General",
  "ia.additionalObs": "Observaciones adicionales",
  "ia.age.alevin": "Alevín (10-12)",
  "ia.age.amateur": "Amateur",
  "ia.age.base": "Fútbol base (6-10 años)",
  "ia.age.cadete": "Cadete (14-16)",
  "ia.age.infantil": "Infantil (12-14)",
  "ia.age.juvenil": "Juvenil (16-18)",
  "ia.age.prebenjamin": "Prebenjamín / Benjamín (8-10)",
  "ia.animation": "Animación ({count}F)",
  "ia.btnClear": "🔄 Limpiar",
  "ia.btnExportPdf": "📄 Exportar PDF",
  "ia.btnGeneratePrevention": "🩺 Generar Plan de Ejercicios",
  "ia.btnGenerateTactical": "✨ Generar Ejercicio",
  "ia.btnSave": "💾 Guardar",
  "ia.capture": "Captura",
  "ia.categoryAge": "CATEGORÍA / EDAD",
  "ia.defaultTitle": "Ejercicio IA {time}",
  "ia.dictationNotSupported": "Tu navegador no soporta el dictado por voz. Usa Chrome en Android para esta función.",
  "ia.dictationStart": "Dictar por voz",
  "ia.dictationStop": "Detener dictado",
  "ia.drawerTitle": "☁️ Biblioteca Cloud",
  "ia.durationMinutes": "{count} min",
  "ia.emptyLibrary": "No hay ejercicios guardados aún.",
  "ia.emptyPlaceholder": "Tu ejercicio aparecerá aquí",
  "ia.emptyResponse": "Respuesta vacía de la IA",
  "ia.intensityLabel": "Intensidade",
  "ia.level.advanced": "Avanzado",
  "ia.level.basic": "Básico",
  "ia.level.intermediate": "Intermedio",
  "ia.libraryBtn": "☁️ Biblioteca ({count})",
  "ia.limitReached": "Has alcanzado el límite de {limit} generaciones de IA este mes. El límite se reinicia el próximo mes.",
  "ia.listening": "🔴 Escuchando... habla ahora",
  "ia.loadingAnalyzing": "⏳ Analizando contexto...",
  "ia.loadingGenerating": "Generando...",
  "ia.loadingUsage": "🔑 IA: Cargando usos...",
  "ia.mainObjective": "OBJETIVO PRINCIPAL",
  "ia.mat.balls": "Balones",
  "ia.mat.bibs": "Petos",
  "ia.mat.cones": "Conos",
  "ia.mat.goals": "Porterías",
  "ia.mat.hurdles": "Vallas",
  "ia.mat.ladder": "Escalera",
  "ia.mat.none": "Sin material específico",
  "ia.mat.rings": "Aros",
  "ia.materials": "MATERIALES",
  "ia.modalDetail": "Detalle",
  "ia.modalLoad": "Cargar",
  "ia.modalNoContent": "Sin contenido.",
  "ia.modalOpenBoard": "Abrir en Pizarra",
  "ia.modePrevention": "Prevención /\nRecuperación",
  "ia.modeTactical": "Ejercicio\nTáctico",
  "ia.noRef": "Sin Ref.",
  "ia.numPlayers": "Nº DE JUGADORES: {count}",
  "ia.obj.aerobic": "Resistencia aeróbica",
  "ia.obj.agility": "Agilidad y coordinación",
  "ia.obj.cooldown": "Vuelta a la calma",
  "ia.obj.crossing": "Centros y llegadas",
  "ia.obj.finishing": "Finalización y remate",
  "ia.obj.positional": "Juego de posición",
  "ia.obj.possession": "Posesión de balón",
  "ia.obj.pressing": "Presión y pressing",
  "ia.obj.speed": "Velocidad",
  "ia.obj.strength": "Fuerza y potencia",
  "ia.obj.transAttDef": "Transición ataque-defensa",
  "ia.obj.transDefAtt": "Transición defensa-ataque",
  "ia.obj.warmup": "Calentamiento",
  "ia.obsPlaceholder": "Ej. Enfocarse en la velocidad de ejecución o en el repliegue defensivo...",
  "ia.phaseLabel": "Fase de jogo",
  "ia.prev.availableMaterial": "Material Disponible",
  "ia.prev.bodyZone": "Zona Corporal",
  "ia.prev.descLabel": "Descripción Clínica / Problema",
  "ia.prev.descPlaceholder": "Ej: Jugador de 16 años con sobrecarga isquiotibial izquierdo tras partido, necesita ejercicios excéntricos y de fortalecimiento...",
  "ia.prev.noMaterial": "Sin material",
  "ia.prev.planType": "Tipo de Plan",
  "ia.prev.playerLevel": "Nivel del Jugador",
  "ia.prev.typePrevention": "Prevención",
  "ia.prev.typeReadaptation": "Readaptación",
  "ia.prev.typeRecovery": "Recuperación",
  "ia.recoveryNotice": "Sessão focada em regeneração muscular e prevenção.",
  "ia.saveError": "Error al guardar el ejercicio. Intenta de nuevo.",
  "ia.saveSuccess": "✅ Guardado en la biblioteca: \"{title}\"",
  "ia.selectPlaceholder": "Seleccionar...",
  "ia.space": "Espacio",
  "ia.space.box": "Área penal",
  "ia.space.full": "Campo completo",
  "ia.space.gym": "Sala / Gimnasio",
  "ia.space.half": "Medio campo",
  "ia.space.small": "Espacio reducido",
  "ia.space.threeQuarter": "3/4 campo",
  "ia.subtitle": "DISEÑO INTELIGENTE DE SESIÓN DE ENTRENAMIENTO",
  "ia.tacticalBoard": "🎬 Pizarra",
  "ia.tacticalRef": "Referencia Táctica (Opcional)",
  "ia.title": "Asistente Táctico de IA",
  "ia.usageRemaining": "🔑 IA: te quedan {count} usos este mes (límite {limit})",
  "ia.validationPrevention": "Por favor describe el caso y selecciona una zona corporal.",
  "ia.validationTactical": "Por favor completa: Edad, Objetivo y Espacio.",
  "ia.zone.adductors": "Aductores",
  "ia.zone.ankle": "Tobillo",
  "ia.zone.calves": "Gemelos",
  "ia.zone.core": "Core / Pelvis",
  "ia.zone.hamstring": "Isquiotibial",
  "ia.zone.knee": "Rodilla",
  "ia.zone.lumbar": "Lumbar",
  "ia.zone.quadriceps": "Cuádriceps",
  "ia.zone.shoulder": "Hombro",
  "install.alreadyInstalled": "¡La App ya está instalada en tu dispositivo!",
  "install.androidDesc": "Pulsa el botón \"Instalar ahora\" abajo o usa el menú de tres puntos (⋮) y elige \"Instalar aplicación\".",
  "install.androidTitle": "Android (Chrome):",
  "install.btnInstall": "Instalar ahora",
  "install.fallbackNotice": "Si no ves el botón de instalación, usa la opción \"Añadir a pantalla de inicio\" de tu navegador.",
  "install.instructions": "Instrucciones:",
  "install.iosDesc": "Pulsa el botón \"Compartir\" (cuadrado con flecha) y selecciona \"Añadir a la pantalla de inicio\".",
  "install.iosTitle": "iOS (Safari):",
  "install.metaDesc": "Instrucciones de instalación paso a paso de la aplicación PWA Mister11 para dispositivos Android e iOS.",
  "install.metaTitle": "Instalar Mister11 — La App de Fútbol para Entrenadores",
  "install.slogan": "El banquillo en tu bolsillo",
  "install.title": "Instalar Mister11",
  "invite.already_registered": "Este correo ya está registrado o invitado en el club.",
  "invite.coach.codePlaceholder": "Código de invitación (6 caracteres)",
  "invite.coach.scanQR": "Escanear QR de invitación",
  "invite.coach.title": "Únete como Entrenador/Staff",
  "invite.generated_error": "Error al generar la invitación.",
  "invite.generated_success": "Invitación generada con éxito.",
  "invite.link_copied": "¡Enlace copiado!",
  "invite.player.codePlaceholder": "Código de equipo",
  "invite.player.scanQR": "Escanear QR del equipo",
  "invite.player.title": "Únete a tu Equipo",
  "joinTeam.account_created": "Cuenta creada exitosamente",
  "joinTeam.already_member": "¡Ya formas parte de este equipo! Cargando tu portal...",
  "joinTeam.google_sign_in": "Sesión iniciada con Google",
  "joinTeam.request_approved": "¡Tu solicitud ha sido aprobada!",
  "joinTeam.request_sent": "¡Solicitud enviada al entrenador!",
  "joinTeam.welcome": "Bienvenido a Mister11",
  "live.action.foul": "Falta",
  "live.action.goal": "Gol",
  "live.action.offside": "Impedimento",
  "live.action.recovery": "Recuperação",
  "live.action.redCard": "Cartão Vermelho",
  "live.action.shot": "Finalização",
  "live.action.turnover": "Perda de bola",
  "live.action.yellowCard": "Cartão Amarelo",
  "live.btn.card_red_own": "Roja (Propia)",
  "live.btn.card_red_rival": "Roja (Rival)",
  "live.btn.card_yellow_own": "Amarilla (Propia)",
  "live.btn.card_yellow_rival": "Amarilla (Rival)",
  "live.btn.corner_against": "Córner en Contra",
  "live.btn.corner_favor": "Córner a Favor",
  "live.btn.counter_not_cut": "Contra No Cortada",
  "live.btn.duel_lost": "Duelo Perdido",
  "live.btn.duel_won": "Duelo Ganado",
  "live.btn.foul_against": "Falta en Contra",
  "live.btn.foul_favor": "Falta a Favor",
  "live.btn.loss": "Pérdida de Balón",
  "live.btn.offside_own": "Fuera de Juego (Propio)",
  "live.btn.offside_rival": "Fuera de Juego (Rival)",
  "live.btn.player_no_finish": "Jugada No Finalizada",
  "live.btn.recovery": "Recuperación",
  "live.btn.save_own": "Parada Portero (Propio)",
  "live.btn.save_rival": "Parada Portero (Rival)",
  "live.btn.shot_off_own": "Tiro Fuera (Propio)",
  "live.btn.shot_off_rival": "Tiro Fuera (Rival)",
  "live.btn.shot_on_own": "Tiro a Puerta (Propio)",
  "live.btn.shot_on_rival": "Tiro a Puerta (Rival)",
  "live.tab.analytics": "Análisis Avanzado",
  "live.tab.capture": "Captura en Vivo",
  "live.tab.players": "Jugadores & CSV",
  "live.tab.tactical": "Campo & Táctica",
  "liveStats.quickMode.advanced": "Opciones avanzadas",
  "liveStats.quickMode.shotSaved": "Tiro registrado",
  "liveStats.quickMode.simple": "Modo simple",
  "liveStats.quickMode.title": "Modo Rápido",
  "liveStats.quickMode.undo": "Deshacer",
  "liveStats.quickMode.undone": "Tiro deshecho",
  "livestats.match_locked_short": "⚠️ Partido finalizado",
  "livestats.match_locked_use_reopen": "⚠️ Partido finalizado — usa Reabrir Acta para corregir.",
  "livestats.post_match_saved": "✅ Contadores post-partido guardados",
  "livestats.select_player_first": "👆 Selecciona un jugador primero",
  "login.account_created": "¡Cuenta creada exitosamente!",
  "login.cancelled": "Inicio de sesión cancelado por el usuario",
  "login.recovery_error": "Error al enviar correo",
  "login.recovery_sent": "Enlace de recuperación enviado a tu correo",
  "login.welcome": "¡Bienvenido a Mister11!",
  "login.write_email_first": "Escribe tu correo primero",
  "match.btn.exportIcs": "EXPORTAR ICS",
  "match.btn.newMatch": "+ NUEVO PARTIDO",
  "match.btn.pdfCalendar": "CALENDARIO PDF",
  "match.defaultMyTeam": "Mi Equipo",
  "match.defaultRival": "Rival",
  "match.filter.all": "Todos",
  "match.filter.finished": "Terminados",
  "match.filter.pending": "Pendientes",
  "match.formationLabel": "Formación: ",
  "match.locked_reopen": "⚠️ Partido finalizado. Reabre el acta para registrar eventos.",
  "match.management.title": "GESTIÓN DE PARTIDOS",
  "match.noVenue": "Sin ubicación",
  "match.sort.cercania": "Más cercanos a hoy",
  "match.sort.estado": "Por Estado / Prioridad",
  "match.sort.fecha_asc": "Fecha (Próximos)",
  "match.sort.fecha_desc": "Fecha (Recientes)",
  "match.sort.label": "Ordenar por",
  "match.sort.lejania": "Más lejanos a hoy",
  "match.status.en_edicion": "EN EDICIÓN",
  "match.status.finalizado": "FINALIZADO",
  "match.status.no_disputado": "NO DISPUTADO",
  "match.status.pendiente": "PENDIENTE",
  "match.venue.local": "Campo Local",
  "match.venue.municipal": "Campo Municipal",
  "match.view.cards": "Tarjetas",
  "match.view.detailed": "Detallado",
  "matchSheet.anomalies_resolved": "✔ {count} anomalía(s) resuelta(s) y acta sincronizada.",
  "matchSheet.auto_badge": "Auto",
  "matchSheet.close_error": "❌ Error al cerrar el acta. Intenta de nuevo.",
  "matchSheet.closed_success": "✅ Acta cerrada. Minutos reales guardados.",
  "matchSheet.closed_with_warnings": "⚠️ Acta cerrada con avisos registrados.",
  "matchSheet.confirm_save_btn": "💾 CONFIRMAR Y GUARDAR ACTA",
  "matchSheet.confirm_save_tooltip": "Guarda todas las correcciones manuales de minutos y actualiza el acta oficial",
  "matchSheet.log_already_clean": "✨ La bitácora ya está limpia. Cero eventos imposibles.",
  "matchSheet.log_debug_error": "❌ Error al depurar bitácora.",
  "matchSheet.manual_allowed_closed": "permitido aunque esté cerrada",
  "matchSheet.manual_badge": "Manual",
  "matchSheet.manual_override_title": "Corrección manual de minutos",
  "matchSheet.prefill_rsvp_empty": "No hay respuestas RSVP pendientes para prellenar.",
  "matchSheet.prefill_rsvp_error": "❌ Error al prellenar desde RSVP.",
  "matchSheet.prefill_rsvp_success": "✅ Estados prellenados desde RSVP.",
  "matchSheet.prefill_smart_error": "❌ Error en prellenado inteligente.",
  "matchSheet.prefill_smart_success": "⚡ Acta prellenada inteligentemente desde alineación y eventos.",
  "matchSheet.referee": "Árbitro",
  "matchSheet.reopen_error": "❌ Error al reabrir el acta.",
  "matchSheet.reopened_info": "🔓 Acta y partido reabiertos para correcciones.",
  "matchSheet.saving": "💾 Guardando...",
  "matchSheet.signatures": "Assinaturas Oficiais",
  "matchSheet.tactical_grade_saved": "⭐ Calificación táctica guardada",
  "matchSheet.weather": "Clima / Gramado",
  "matches.finish_error": "❌ Error al guardar finalización:",
  "matches.lineup.benchTitle": "BANQUILLO DE SUPLENTES",
  "matches.lineup.downloadPng": "DESCARGAR PNG",
  "matches.lineup.emptySlot": "Vacío",
  "matches.lineup.exportingPng": "EXPORTANDO...",
  "matches.lineup.subtitle": "Pizarra gráfica con once titular y banquillo de suplentes",
  "matches.lineup.title": "Alineación Táctica y Banquillo",
  "matches.log_cleanse_error": "❌ Error al depurar la bitácora.",
  "matches.log_cleansed": "🧹 Bitácora depurada con éxito. {count} registros saneados.",
  "matches.repair_error": "❌ Error al reparar el partido.",
  "matches.repaired": "✅ Partido reparado y persistido con éxito.",
  "matches.warnings.auditHide": "Ocultar auditoría",
  "matches.warnings.auditNote": "Bitácora depurada el {date}: {count} anomalías aisladas y resueltas.",
  "matches.warnings.auditShow": "Ver detalle",
  "matches.warnings.bannerTitle": "Este partido contenía {count} anomalías o datos legacy aislados automáticamente.",
  "matches.warnings.chipTooltip": "{count} anomalías detectadas en bitácora (clic para ver y resolver en Acta Oficial)",
  "matches.warnings.cleanseBtn": "Depurar bitácora",
  "matches.warnings.cleansing": "Depurando...",
  "matches.warnings.hideDetails": "Ocultar detalles",
  "matches.warnings.resolvedSuccess": "✔ {count} anomalía(s) resuelta(s) y acta sincronizada.",
  "matches.warnings.showDetails": "Ver lista",
  "month.Abr": "Abr",
  "month.Ago": "Ago",
  "month.Dic": "Dic",
  "month.Ene": "Ene",
  "month.Feb": "Feb",
  "month.Jul": "Jul",
  "month.Jun": "Jun",
  "month.Mar": "Mar",
  "month.May": "May",
  "month.Nov": "Nov",
  "month.Oct": "Oct",
  "month.Sep": "Sep",
  "nav.admin": "ADMINISTRACIÓN",
  "nav.dashboard": "DASHBOARD",
  "nav.equipo": "MI EQUIPO",
  "nav.ia": "IA GENERADORA",
  "nav.partidos": "PARTIDOS",
  "nav.pizarra": "PIZARRA TÁCTICA",
  "nav.planificacion": "PLANIFICACIÓN",
  "nav.sesiones": "SESIONES",
  "nav.tests": "TESTS",
  "notifPrefs.chatDesc": "Avisos de nuevos mensajes en el chat de la plantilla",
  "notifPrefs.chatTitle": "Mensajes del Equipo",
  "notifPrefs.errorToast": "Error al guardar las preferencias de notificación",
  "notifPrefs.frequencyCapDesc": "Número máximo de notificaciones diarias",
  "notifPrefs.frequencyCapTitle": "Límite de Frecuencia",
  "notifPrefs.matchDesc": "Alertas sobre convocatorias, horarios y partidos próximos",
  "notifPrefs.matchTitle": "Convocatorias y Partidos",
  "notifPrefs.perDay": "al día",
  "notifPrefs.quietHoursDesc": "No recibir notificaciones push en esta franja horaria",
  "notifPrefs.quietHoursEnd": "Fin de silencio",
  "notifPrefs.quietHoursStart": "Inicio de silencio",
  "notifPrefs.quietHoursTitle": "Horas de Silencio",
  "notifPrefs.reminderTime": "Hora del recordatorio",
  "notifPrefs.savedToast": "Preferencias de notificación guardadas con éxito",
  "notifPrefs.title": "Preferencias de Notificaciones",
  "notifPrefs.wellnessDesc": "Recordatorio diario para completar el formulario de salud",
  "notifPrefs.wellnessTitle": "Check-in de Bienestar",
  "notifications.empty": "No tienes notificaciones pendientes.",
  "notifications.individualPlanAssigned": "Plan individual asignado correctamente",
  "notifications.individualPlanRemoved": "Plan individual eliminado",
  "notifications.newExerciseSaved": "Nuevo ejercicio guardado: {name}",
  "notifications.newMatchRegistered": "Nuevo partido registrado vs {rival}",
  "notifications.newPlayerAdded": "Nuevo jugador añadido: {name}",
  "notifications.newSessionCreated": "Nueva sesión creada: {title}",
  "notifications.predefinedExerciseError": "No puedes eliminar un ejercicio predefinido del sistema.",
  "notifications.sessionImportedSuccess": "Sesión \"{title}\" importada con éxito",
  "notifications.teamPlanAssigned": "Plan de equipo asignado correctamente",
  "notifications.teamPlanRemoved": "Plan de equipo eliminado",
  "notifications.timeHoursAgo": "Hace {hours} horas",
  "notifications.timeJustNow": "Hace un momento",
  "notifications.timeMinAgo": "Hace {min} min",
  "notifications.timeNow": "Ahora",
  "notifications.title": "Notificaciones",
  "notifications.weeklyReportReady": "📋 Tu informe semanal del equipo ya está listo. ¡Descárgalo en el panel principal!",
  "page.admin": "ADMINISTRACIÓN",
  "page.dashboard": "DASHBOARD",
  "page.default": "Mister11",
  "page.equipo": "MI EQUIPO",
  "page.ia": "IA GENERADORA",
  "page.partidos": "PARTIDOS",
  "page.pizarra": "PIZARRA TÁCTICA",
  "page.planificacion": "PLANIFICACIÓN",
  "page.sesiones": "SESIONES",
  "page.tests": "TESTS",
  "partidos.tab.analisis": "Análisis",
  "partidos.tab.lista": "Partidos",
  "paywall.androidBackToInfo": "Volver",
  "paywall.androidDialogText": "La suscripción se gestiona de forma centralizada desde nuestra plataforma web. Visita mister11.app para contratar tu plan y recibe el acceso al instante en esta app.",
  "paywall.androidDialogTitle": "Planes Mister11 PRO",
  "paywall.androidHaveCode": "Ya tengo un código",
  "paywall.androidNotNow": "Ahora no",
  "paywall.androidOpenWeb": "Abrir mister11.app",
  "paywall.androidRedeemDesc": "Introduce tu código corporativo o promocional para activar tu plan PRO al instante.",
  "paywall.androidRedeemTitle": "Canjear Código",
  "paywall.benefit1": "Sesiones de entrenamiento ilimitadas",
  "paywall.benefit2": "IA Generadora de tareas ilimitada",
  "paywall.benefit3": "Exportación de informes técnicos en PDF",
  "paywall.benefit4": "Suite avanzada de estadísticas y métricas",
  "paywall.clubBadge": "PLAN CLUB",
  "paywall.freeLimitMsg": "Has alcanzado el límite del plan gratuito.",
  "paywall.proBadge": "PLAN PRO",
  "paywall.promoPlaceholder": "Código (ej. BETA2026)",
  "paywall.promoSectionDesc": "Introduce tu código (ej. BETA2026) para activar el acceso inmediatamente.",
  "paywall.promoSectionTitle": "🔑 ¿Tienes un código promocional o de prueba beta?",
  "paywall.title": "Desbloquea el Potencial Completo",
  "paywall.upgradeBtn": "Actualizar a PRO",
  "paywall.upgradeClubBtn": "Ver Planes CLUB",
  "placeholder.teamName": "Ej. Rayo Vallecano Juvenil A",
  "plan.category": "CATEGORÍA",
  "plan.categoryPlaceholder": "Ej: Infantil A",
  "plan.chip.compet": "Compet.",
  "plan.chip.sessions": "Sesiones",
  "plan.chip.work": "Trabajo",
  "plan.coach": "COACH",
  "plan.coachPlaceholder": "Nombre entrenador",
  "plan.dateRange": "RANGO DE FECHAS",
  "plan.days.friday": "V",
  "plan.days.monday": "L",
  "plan.days.saturday": "S",
  "plan.days.sunday": "D",
  "plan.days.thursday": "J",
  "plan.days.tuesday": "M",
  "plan.days.wednesday": "X",
  "plan.end": "Fin",
  "plan.exportPdf": "EXPORTAR PDF",
  "plan.fatigaWarning": "⚠️ Entreno en MD-1 — potencial fatiga",
  "plan.matchDay": "⚽ Día de Match:",
  "plan.meso.backToMeso": "← Volver a Mesociclos",
  "plan.meso.competition": "COMPETICIÓN",
  "plan.meso.exportPdf": "Exportar mes a PDF",
  "plan.meso.load": "CARGA",
  "plan.meso.month": "MES",
  "plan.meso.monthDetail": "Detalle del Mes: ",
  "plan.meso.predominantType": "TIPO PREDOMINANTE",
  "plan.meso.sessions": "SESIONES",
  "plan.meso.totalVolume": "VOLUMEN TOTAL",
  "plan.meso.weeks": "Semanas",
  "plan.metricSessions": "SESIONES",
  "plan.metrics.macrocycle": "MACRO-CICLO",
  "plan.metrics.mesocycle": "MESO-CICLO",
  "plan.metrics.mesocyclesOverview": "MESO-CICLOS (VISTA GENERAL)",
  "plan.micro.matchDayLabel": "🏆 Día de Partido",
  "plan.micro.physical": "Físico",
  "plan.micro.rest": "Descanso",
  "plan.micro.selectWeek": "SELECCIONAR SEMANA",
  "plan.micro.sessionLabel": "Sesión ({duration} min)",
  "plan.micro.tactical": "Táctico",
  "plan.micro.technical": "Técnico",
  "plan.micro.week": "Semana",
  "plan.obj.mental": "OBJETIVO MENTAL",
  "plan.obj.mentalPlaceholder": "Desarrollar la concentración y el trabajo en equipo...",
  "plan.obj.physical": "OBJETIVO FÍSICO",
  "plan.obj.physicalPlaceholder": "Mejorar la resistencia aeróbica y la velocidad de reacción...",
  "plan.obj.seasonGeneral": "OBJETIVO GENERAL DE TEMPORADA",
  "plan.obj.seasonGeneralPlaceholder": "Describe el objetivo principal de la temporada...",
  "plan.obj.tactical": "OBJETIVO TÁCTICO",
  "plan.obj.tacticalPlaceholder": "Dominar la presión alta y la salida de balón...",
  "plan.obj.technical": "OBJETIVO TÉCNICO",
  "plan.obj.technicalPlaceholder": "Mejorar el control y el pase en espacios reducidos...",
  "plan.pdf.error": "Error al exportar PDF.",
  "plan.pdf.exported": "PDF exportado ✓",
  "plan.period.comp": "Comp",
  "plan.period.prep": "Prep",
  "plan.period.trans": "Trans",
  "plan.reschedule.body": "El día de partido seleccionado para esta semana es {day}. Al confirmar, los {count} días de entreno se ajustarán automáticamente para equilibrar la carga previa al encuentro competitivo.",
  "plan.reschedule.confirm": "Confirmar Reubicación",
  "plan.reschedule.title": "¿Reubicar días de entrenamiento?",
  "plan.reschedule.toastSuccess": "✓ Entrenamientos reubicados en base a MD",
  "plan.reubicarBtn": "🔄 Reubicar entreno según nuevo día",
  "plan.save": "GUARDAR",
  "plan.saving": "GUARDANDO...",
  "plan.seasonObjective": "OBJETIVO GENERAL DE LA TEMPORADA",
  "plan.seasonObjectivePlaceholder": "Introduce el objetivo general de la temporada...",
  "plan.seasonVolume": "VOLUMEN TEMPORADA",
  "plan.sessionDuration": "Duración sesión:",
  "plan.start": "Inicio",
  "plan.strategicPlanning": "PLANIFICACIÓN ESTRATÉGICA",
  "plan.tab.macrociclo": "MACROCICLO",
  "plan.tab.mesociclo": "MESOCICLO",
  "plan.tab.microciclo": "MICROCICLO",
  "plan.tab.objetivos": "OBJETIVOS",
  "plan.totalMinutesLabel": "minutos totales",
  "plan.trainingDays": "DÍAS DE ENTRENAMIENTO",
  "plan.volumeUnit": "min/sem",
  "planning.generating_pdf": "Generando PDF del mesociclo...",
  "planning.generating_pdf_generic": "Generando PDF...",
  "planning.login_required": "Inicia sesión para guardar",
  "planning.matrix.daysPerWeek": "días/sem",
  "planning.matrix.loadDynamics": "DINÁMICA CARGA",
  "planning.matrix.matchDay": "DÍA PARTIDO",
  "planning.matrix.microType": "TIPO MICRO",
  "planning.matrix.microcycleNo": "Nº MICROCICLO",
  "planning.matrix.months": "MESES",
  "planning.matrix.pctPhysical": "% FÍSICO",
  "planning.matrix.pctTactical": "% TÁCTICO",
  "planning.matrix.pctTechnical": "% TÉCNICO",
  "planning.matrix.periods": "PERÍODOS",
  "planning.matrix.physicalTest": "TEST FÍSICO",
  "planning.matrix.savePlanning": "GUARDAR PLANIFICACIÓN",
  "planning.matrix.sessions": "SESIONES",
  "planning.matrix.title": "MATRIZ DE PLANIFICACIÓN",
  "planning.matrix.volumeMin": "VOLUMEN (MIN)",
  "planning.microType.ajuste": "Ajuste",
  "planning.microType.carga": "Carga",
  "planning.microType.choque": "Choque",
  "planning.microType.comp": "Comp",
  "planning.microType.recup": "Recup",
  "planning.pdf_error": "Error al exportar PDF.",
  "planning.pdf_exported": "PDF exportado ✓",
  "planning.pdf_month_not_found": "Error: No se encontró la información del mes.",
  "planning.pdf_success": "PDF del mesociclo generado con éxito ✓",
  "planning.save_error": "Error al guardar.",
  "planning.saved": "Planificación guardada ✓",
  "plans.assignModal.ageBlocked": "No apto para la edad del jugador",
  "plans.assignModal.assignBtn": "Asignar Plan",
  "plans.assignModal.frequency": "Frecuencia",
  "plans.assignModal.homeAlternative": "Alternativa casera",
  "plans.assignModal.minAge": "Edad mín. segura",
  "plans.assignModal.planName": "Nombre del Plan (opcional)",
  "plans.assignModal.preferredMaterial": "Material preferido",
  "plans.assignModal.reason": "Motivo",
  "plans.assignModal.searchPlaceholder": "Buscar ejercicio...",
  "plans.assignModal.selectExercises": "Seleccionar Ejercicios",
  "plans.assignModal.supervisionRequired": "Requiere supervisión presencial",
    "exercise.illustrationPending": "Ilustración pendiente — sigue la descripción textual",
  "exercise.illustrationNotice": "Protocolo clínico: validación visual técnica en curso sin generación sintética",
  "exercise.coachingPoints": "Puntos clave de ejecución",
  "exercise.minSafeAge": "Edad mín. segura",
  "exercise.preferredMaterial": "Material preferido",
  "exercise.homeAlternative": "Alternativa casera",
  "exercise.supervisionRequired": "Requiere supervisión presencial",
  "plans.assignModal.title": "Asignar Plan de Ejercicios",
  "plans.assignedPlan": "Plan Asignado",
  "plans.badgeIndividual": "INDIVIDUAL",
  "plans.badgeTeam": "EQUIPO",
  "plans.coachFeedback": "Instrucciones del Míster",
  "plans.copyLink": "COPIAR ENLACE",
  "plans.daily": "Diario",
  "plans.exercisesHeader": "Ejercicios para Hoy",
  "plans.linkCopied": "¡ENLACE COPIADO!",
  "plans.loadingPlans": "Cargando planes...",
  "plans.noPlansAssigned": "El jugador no tiene planes asignados.",
  "plans.recommendExercises": "Recomendar Ejercicios",
  "plans.routinesAndPrevention": "Rutinas y Prevención",
  "plans.shareNotice": "Comparte este enlace con tus jugadores para que puedan ver su plan de ejercicios sin necesidad de iniciar sesión:",
  "plans.sharePlan": "🔗 Compartir Plan",
  "plans.streakDays.one": "Racha: {count} día",
  "plans.streakDays.other": "Racha: {count} días",
  "player.achievements.bronzeBadge": "25 XP · Reto Semanal",
  "player.achievements.completed": "¡Completado!",
  "player.achievements.filterAll": "Todos ({count})",
  "player.achievements.filterBiweekly": "Quincenales (Plata)",
  "player.achievements.filterBronze": "Bronce ({count})",
  "player.achievements.filterGold": "Oro ({count})",
  "player.achievements.filterSeason": "Temporada (Oro)",
  "player.achievements.filterSilver": "Plata ({count})",
  "player.achievements.filterWeekly": "Semanales (Bronce)",
  "player.achievements.goldBadge": "100 XP · Hito de Temporada (Máximo)",
  "player.achievements.inProgress": "{percent}% completado",
  "player.achievements.intentionOnlyNote": "(Reto de intención)",
  "player.achievements.loading": "Cargando vitrina de logros...",
  "player.achievements.noSessions": "Sin sesiones programadas esta semana",
  "player.achievements.pendingActa": "Pendiente de acta",
  "player.achievements.season": "Temporada 2026-27 · Fútbol Formativo",
  "player.achievements.seasonPeriod": "Temporada 2026-27",
  "player.achievements.silverBadge": "50 XP · Reto Quincenal",
  "player.achievements.subtabJuegos": "Juegos y Retos",
  "player.achievements.subtabRanking": "Ranking",
  "player.achievements.subtabVitrina": "Vitrina",
  "player.achievements.thisFortnight": "Esta quincena",
  "player.achievements.thisWeek": "Esta semana",
  "player.achievements.tierBronze": "Bronce",
  "player.achievements.tierGold": "Oro",
  "player.achievements.tierSilver": "Plata",
  "player.achievements.title": "Tus Logros Deportivos",
  "player.achievements.titleParent": "Logros de {name}",
  "player.achievements.unlocked": "Desbloqueados",
  "player.achievements.xpSubtitle": "Ganada desbloqueando retos",
  "player.achievements.xpTitle": "XP de Logros",
  "player.addPlayer": "+ Añadir Jugador",
  "player.age": "Edad",
  "player.assists": "Asistencias",
  "player.attendance.absent": "Ausente",
  "player.attendance.excused": "Justificado",
  "player.attendance.injured": "Lesionado",
  "player.attendance.monthlyTitle": "Registro Mensual de Asistencia",
  "player.attendance.present": "Presente",
  "player.attendance.rate": "Tasa de Asistencia Anual",
  "player.avgRating": "Nota Media",
  "player.bmi": "IMC",
  "player.bothFeet": "Ambidiestro",
  "player.cards": "Tarjetas",
  "player.category": "Categoría",
  "player.chat.block.btn": "Sí, Bloquear",
  "player.chat.block.confirm": "¿Seguro que deseas bloquear la comunicación con {name}? No podrán enviarse mensajes en este canal privado hasta que lo desbloquees.",
  "player.chat.block.success": "Usuario bloqueado correctamente.",
  "player.chat.block.title": "¿Bloquear usuario?",
  "player.chat.block_error": "Error al bloquear usuario.",
  "player.chat.blocked.banner": "🚫 La comunicación en este chat privado está bloqueada.",
  "player.chat.blocked.unblockHint": "Puedes gestionar los usuarios bloqueados desde Perfil > Privacidad.",
  "player.chat.coachSender": "👑 Cuerpo Técnico",
  "player.chat.emptyDesc": "Escribe un mensaje o pulsa una de las opciones rápidas arriba.",
  "player.chat.emptyTitle": "Aún no hay mensajes en este canal.",
  "player.chat.headerSubtitle": "{team} · Mensajes privados y confidenciales",
  "player.chat.headerTitle": "Canal Directo con el Cuerpo Técnico",
  "player.chat.loading": "Cargando conversación...",
  "player.chat.menu.block": "Bloquear usuario",
  "player.chat.menu.copied": "Texto copiado al portapapeles",
  "player.chat.menu.copy": "Copiar texto",
  "player.chat.menu.report": "Denunciar mensaje",
  "player.chat.moderation.badge": "Reportes",
  "player.chat.moderation.deleteConfirm": "¿Eliminar este mensaje definitivamente del chat?",
  "player.chat.moderation.deleteMsg": "Eliminar mensaje",
  "player.chat.moderation.empty": "No hay mensajes denunciados pendientes de revisión.",
  "player.chat.moderation.msgDeleted": "Mensaje eliminado del chat.",
  "player.chat.moderation.resolve": "Marcar como resuelto",
  "player.chat.moderation.resolved": "Reporte resuelto.",
  "player.chat.moderation.title": "Moderación de Mensajes",
  "player.chat.now": "Ahora",
  "player.chat.optionsAria": "Opciones del mensaje",
  "player.chat.placeholder": "Escribe un mensaje al míster...",
  "player.chat.placeholderCoach": "Escribe una respuesta a {name}...",
  "player.chat.playerSender": "👤 Jugador",
  "player.chat.qr.coachEarly": "⏰ Acuérdate de llegar 15 min antes",
  "player.chat.qr.coachReceived": "👍 Recibido, nos vemos en el campo",
  "player.chat.qr.coachRest": "🩺 Descansa y avísame si persiste el dolor",
  "player.chat.qr.coachSquad": "📋 Convocatoria confirmada, ¡a por todas!",
  "player.chat.qr.discomfort": "🩺 Tengo molestia muscular",
  "player.chat.qr.late10": "🏃 Llego 10 min tarde",
  "player.chat.qr.ready": "✅ Todo listo para el partido",
  "player.chat.qr.talk": "❓ Míster, ¿puedo hablar contigo?",
  "player.chat.qr.transport": "🚗 Necesito transporte para el desplazamiento",
  "player.chat.quickMsg.injury": "Tengo una molestia muscular y no podré entrenar al 100%.",
  "player.chat.quickMsg.late": "Llegaré 5 minutos tarde.",
  "player.chat.quickMsg.ready": "¡Listo para el partido del fin de semana!",
  "player.chat.quickMsg.study": "No podré asistir por motivos de estudio/exámenes.",
  "player.chat.quickReplies": "⚡ Mensajes rápidos:",
  "player.chat.quickTitle": "Mensajes Rápidos:",
  "player.chat.report.detailsPlaceholder": "Añade detalles adicionales si lo deseas (opcional)...",
  "player.chat.report.quotedMessage": "Mensaje denunciado:",
  "player.chat.report.reason.harassment": "Acoso, intimidación o conducta indebida",
  "player.chat.report.reason.inappropriate": "Contenido inapropiado o lenguaje ofensivo",
  "player.chat.report.reason.other": "Otro motivo",
  "player.chat.report.reason.spam": "Spam o mensajes no deseados",
  "player.chat.report.selectReason": "Selecciona el motivo:",
  "player.chat.report.submit": "Enviar Denuncia",
  "player.chat.report.submitting": "Enviando...",
  "player.chat.report.subtitle": "Revisamos todas las denuncias para garantizar un entorno seguro y respetuoso.",
  "player.chat.report.success": "Denuncia enviada correctamente. El cuerpo técnico revisará el mensaje.",
  "player.chat.report.title": "Denunciar Mensaje",
  "player.chat.report_error": "Error al enviar la denuncia.",
  "player.chat.send": "Enviar",
  "player.chat.sendAria": "Enviar mensaje",
  "player.chat.title": "Chat con el Míster",
  "player.chat.unblock.btn": "Desbloquear",
  "player.chat.unblock.confirm": "¿Deseas desbloquear a {name} y reanudar la mensajería?",
  "player.chat.unblock.success": "Usuario desbloqueado.",
  "player.closeProfile": "Cerrar ficha",
  "player.coachRating": "Nota Míster",
  "player.deleteConfirm": "¿Seguro que deseas eliminar a {name} del equipo?",
  "player.deleteFromTeam": "Eliminar a {name} del Equipo",
  "player.editProfile": "Editar Ficha",
  "player.foot": "Pie dominante",
  "player.foot.both": "Ambidiestro",
  "player.foot.left": "Izquierdo",
  "player.foot.right": "Derecho",
  "player.goalAbbr": "GOL",
  "player.goals": "GOLES",
  "player.height": "Altura",
  "player.heightAbbr": "Alt",
  "player.home.almostBronze": "¡LOGRO CASI CONSEGUIDO! (BRONCE)",
  "player.home.almostGold": "¡LOGRO CASI CONSEGUIDO! (ORO)",
  "player.home.almostSilver": "¡LOGRO CASI CONSEGUIDO! (PLATA)",
  "player.home.announcements": "Comunicados del Equipo",
  "player.home.closestAchievement": "Próximo Reto",
  "player.home.goals": "GOLES EN PARTIDOS",
  "player.home.goalsSub": "{goals} en {matches} ({minutes}')",
  "player.home.goalsSummary": "{goals} en {matches} ({minutes}')",
  "player.home.greeting": "¡Hola, {name}!",
  "player.home.nextChallenge": "PRÓXIMO RETO",
  "player.home.nextEventBadge": "PRÓXIMA CONVOCATORIA",
  "player.home.nextMatch": "Próxima Convocatoria",
  "player.home.noAnnouncements": "No hay avisos recientes del entrenador.",
  "player.home.noUpcoming": "No hay entrenamientos programados para los próximos días.",
  "player.home.rsvpBtn": "Confirmar Asistencia (RSVP)",
  "player.home.rsvpPrompt": "¿Asistirás a esta sesión?",
  "player.home.scheduled": "PROGRAMADO",
  "player.home.soon": "Próximamente",
  "player.home.streak": "RACHA DE ASISTENCIA",
  "player.home.streakSession": "{count} sesión consecutiva",
  "player.home.streakSessions": "{count} sesiones consecutivas",
  "player.home.streakSub": "{count} consecutivas",
  "player.home.subtitle": "Todo listo para tu próximo entrenamiento.",
  "player.home.viewDetails": "Ver Detalles",
  "player.home.viewSchedule": "Ver Calendario Completo",
  "player.leaderboard.accumulatedXP": "{xp} XP acumulados",
  "player.leaderboard.challenges": "retos",
  "player.leaderboard.colMetric": "MÉTRICA",
  "player.leaderboard.colPlayer": "COMPAÑERO",
  "player.leaderboard.colRank": "PUESTO",
  "player.leaderboard.colXP": "XP TOTAL",
  "player.leaderboard.footerDesc": "El compromiso en los entrenamientos y el juego en equipo son el camino para subir de rango en Mister11.",
  "player.leaderboard.footerTitle": "¡Cada sesión suma para el equipo!",
  "player.leaderboard.leadingTeam": "👑 ¡Liderando la clasificación del equipo!",
  "player.leaderboard.matchesPlayedShort": "PJ",
  "player.leaderboard.protectedData": "Datos de equipo protegidos",
  "player.leaderboard.subtitle": "Suma puntos XP con tu asistencia a entrenamientos, minutos jugados y retos completados.",
  "player.leaderboard.tabAchievements": "Logros",
  "player.leaderboard.tabAttendance": "Asistencia",
  "player.leaderboard.tabGlobal": "Global XP",
  "player.leaderboard.tabMatches": "Partidos y Minutos",
  "player.leaderboard.tierTag": "Rango {tier}",
  "player.leaderboard.title": "TABLA DE RENDIMIENTO DEL EQUIPO",
  "player.leaderboard.xpDiff": "¡A solo {xp} XP del Top #{rank}!",
  "player.leaderboard.youChip": "TÚ",
  "player.leaderboard.yourRank": "Tu Posición:",
  "player.leftFoot": "Izquierdo",
  "player.linkedAccount": "Cuenta Vinculada",
  "player.matchHistory": "Historial de Partidos",
  "player.matchHistoryEmpty": "No hay partidos registrados para este jugador.",
  "player.matches": "MATCHS",
  "player.matchesAbbr": "PJ",
  "player.minutes": "MINUTOS",
  "player.minutesPlayed": "Minutos jugados",
  "player.nav.achievements": "Logros",
  "player.nav.chat": "Mister",
  "player.nav.home": "Inicio",
  "player.nav.profile": "Ficha",
  "player.nav.schedule": "Agenda",
  "player.nav.stats": "Stats",
  "player.nav.tests": "Tests",
  "player.noAccount": "Sin cuenta (edita el perfil para vincular)",
  "player.noLinkedAccount": "Sin cuenta vinculada",
  "player.notifications.promptBtn": "ACTIVAR AVISOS",
  "player.notifications.promptDesc": "Recibe al instante las convocatorias oficiales del míster y recordatorios 2h antes de cada entreno.",
  "player.notifications.promptLater": "Más tarde",
  "player.notifications.promptTitle": "¿Deseas activar avisos de convocatorias y partidos?",
  "player.openChat": "Abrir Chat con el jugador",
  "player.plans.completeExercise": "Marcar como completado",
  "player.plans.completedExercise": "¡Ejercicio completado!",
  "player.plans.error": "Error",
  "player.plans.noPlans": "No tienes planes activos asignados",
  "player.plans.posturalKey": "Clave Postural",
  "player.plans.prevention": "Prevención",
  "player.plans.reps": "Repeticiones",
  "player.plans.rest": "Descanso",
  "player.plans.sets": "Series",
  "player.plans.stepByStep": "EJECUCIÓN PASO A PASO",
  "player.plans.subtitle": "Rutinas personalizadas asignadas por el cuerpo técnico",
  "player.plans.title": "Planes de Entrenamiento Individual",
  "player.portal.activeCard": "Ficha activa:",
  "player.portal.family": "PORTAL FAMILIA",
  "player.portal.joinWithCode": "Unirme a un Equipo con Código",
  "player.portal.loading": "Cargando tu portal de jugador...",
  "player.portal.logoutAria": "Cerrar Sesión o Cambiar Cuenta",
  "player.portal.myTeam": "Mi Equipo",
  "player.portal.notLinkedDesc": "Aún no estás vinculado a ningún equipo como jugador. Pídele el código de acceso a tu entrenador o pulsa a continuación para unirte a tu plantilla.",
  "player.portal.notLinkedTitle": "¡Hola, {name}!",
  "player.portal.parentView": "Vista de Padre",
  "player.portal.player": "PORTAL JUGADOR",
  "player.portal.selectTeamAria": "Seleccionar equipo de jugador",
  "player.portal.settingsAria": "Configuración y Ajustes",
  "player.portal.switchToCoach": "Cambiar a Modo Entrenador",
  "player.portal.themeDarkAria": "Cambiar a modo oscuro",
  "player.portal.themeLightAria": "Cambiar a modo claro",
  "player.primaryPosition": "Posición Principal",
  "player.profile.account": "Cuenta de Acceso",
  "player.profile.account_deleted": "Tu cuenta ha sido eliminada correctamente.",
  "player.profile.activeCard": "Ficha activa:",
  "player.profile.age": "Edad",
  "player.profile.attendance": "ASISTENCIA",
  "player.profile.blockedUsers": "Usuarios Bloqueados",
  "player.profile.bmi": "IMC",
  "player.profile.bodyComp": "📊 Composición Corporal",
  "player.profile.bodyCompDesc": "Los parámetros antropométricos son supervisados periódicamente por el cuerpo técnico para optimizar tu rendimiento y plan de preparación física.",
  "player.profile.category": "Categoría",
  "player.profile.consentClearSign": "Borrar firma",
  "player.profile.consentDrawLabel": "Firma del Padre / Tutor (con el dedo o ratón):",
  "player.profile.consentHealthCheck": "Datos de Salud y Molestias: Autorizo el registro del check-in diario de bienestar y reporte de fatiga muscular con fines exclusivos de prevención de lesiones.",
  "player.profile.consentModalDesc": "Conforme al Reglamento General de Protección de Datos (RGPD) y la LOPDGDD, el padre, madre o tutor legal puede autorizar o denegar los siguientes tratamientos de datos del menor:",
  "player.profile.consentModalTitle": "Consentimiento Parental Digital",
  "player.profile.consentParentNameLabel": "Nombre y Apellidos del Padre / Tutor *",
  "player.profile.consentPending": "Pendiente de Firma",
  "player.profile.consentSaveSign": "Confirmar y Guardar Firma",
  "player.profile.consentSaving": "Guardando...",
  "player.profile.consentSigned": "Firmado y Válido",
  "player.profile.consentStatus": "Estado de Consentimiento Parental",
  "player.profile.consentTestsCheck": "Tests y Rendimiento: Autorizo la realización de evaluaciones autónomas de velocidad, salto y resistencia para seguimiento técnico.",
  "player.profile.consent_error": "Error al guardar consentimiento.",
  "player.profile.consent_saved": "Consentimiento parental actualizado exitosamente.",
  "player.profile.deleteAccount": "Eliminar Cuenta y Datos (RGPD)",
  "player.profile.deleteAccountDesc": "Esta acción es permanente e irreversible. Se eliminará tu acceso de usuario, tu historial deportivo, consentimientos y perfil en Mister11.",
  "player.profile.deleteAccountTitle": "¿Eliminar tu cuenta?",
  "player.profile.deleteConfirmBtn": "Sí, Eliminar Cuenta",
  "player.profile.deleteConfirmPrompt": "Escribe ELIMINAR para confirmar:",
  "player.profile.deleteConfirmWord": "ELIMINAR",
  "player.profile.deleteDeleting": "Eliminando...",
  "player.profile.discomfortQuestion": "2. ¿Tienes alguna molestia o dolor muscular?",
  "player.profile.discomfortZone": "Zona de la molestia:",
  "player.profile.dorsal": "DORSAL",
  "player.profile.foot": "Pie dominante",
  "player.profile.general": "GENERAL",
  "player.profile.goals": "Goles",
  "player.profile.hasDiscomfort": "🟡 Tengo molestias",
  "player.profile.health": "SALUD",
  "player.profile.height": "Altura",
  "player.profile.logout": "Cerrar Sesión",
  "player.profile.matches": "Partidos",
  "player.profile.minutes": "Minutos",
  "player.profile.moodQuestion": "3. ¿Nivel de ánimo y energía hoy? (1 = Bajo, 5 = A tope)",
  "player.profile.noBlockedUsers": "No tienes ningún usuario bloqueado actualmente.",
  "player.profile.noDiscomfort": "🟢 Sin molestias",
  "player.profile.parentBadge": "Vista Familiar / Tutor",
  "player.profile.parent_name_required": "Escribe el nombre del padre/tutor.",
  "player.profile.physical": "FÍSICO",
  "player.profile.plans": "PLANES",
  "player.profile.position": "Posición Principal",
  "player.profile.sendWellness": "Guardar Check-in de Salud",
  "player.profile.signConsent": "Firmar / Editar Consentimiento",
  "player.profile.sleepQuestion": "1. ¿Cómo dormiste y qué tal descansaste? (1 = Muy mal, 5 = Excelente)",
  "player.profile.switchToCoach": "Cambiar a Modo Entrenador",
  "player.profile.weight": "Peso",
  "player.profile.wellnessCheckin": "CHECK-IN DIARIO DE BIENESTAR",
  "player.profile.wellnessSent": "¡Ya has enviado tu check-in de hoy! Puedes actualizarlo si cambian tus sensaciones.",
  "player.profile.wellness_saved": "¡Check-in de bienestar guardado correctamente!",
  "player.profile.years": "años",
  "player.rightFoot": "Derecho",
  "player.schedule.attendance_error": "Error al guardar asistencia.",
  "player.schedule.backToCurrentMonth": "Volver al mes actual",
  "player.schedule.calledBadge": "📋 Convocado",
  "player.schedule.calledUp": "Convocado",
  "player.schedule.calledUpDesc": "Has sido convocado por el cuerpo técnico. ¡Da el 100% en el campo!",
  "player.schedule.coachRating": "Nota del Míster:",
  "player.schedule.emptyDesc": "Tu entrenador aún no ha programado sesiones o partidos en este mes.",
  "player.schedule.match": "PARTIDO",
  "player.schedule.minPlayed": "min jugados",
  "player.schedule.noEvents": "No hay eventos programados para este mes.",
  "player.schedule.noMinutes": "Sin minutos",
  "player.schedule.notCalled": "No convocado para esta jornada",
  "player.schedule.notCalledDesc": "¡Mucho ánimo y a seguir dándolo todo en los entrenamientos!",
  "player.schedule.pendingVerification": "Pendiente de verificación",
  "player.schedule.promptParent": "¿Asistirá {name} a este evento?",
  "player.schedule.promptSelf": "¿Asistirás a esta sesión?",
  "player.schedule.reserve": "Reserva / Convocatoria en espera",
  "player.schedule.reserveDesc": "Mantente atento por si se produce alguna vacante de última hora.",
  "player.schedule.rsvpConfirmed": "Asistencia confirmada: \"{status}\"",
  "player.schedule.rsvpGoing": "Iré",
  "player.schedule.rsvpJustified": "Justificado",
  "player.schedule.rsvpLate": "Llegaré tarde",
  "player.schedule.rsvpNotGoing": "No iré",
  "player.schedule.starter": "Titular",
  "player.schedule.substitute": "Suplente",
  "player.schedule.title": "Agenda del Equipo",
  "player.schedule.training": "ENTRENAMIENTO",
  "player.settings.dangerZone": "Zona de Privacidad (RGPD)",
  "player.settings.deleteAccountDesc": "Elimina permanentemente tu usuario y desvincula tus datos personales.",
  "player.settings.installApp": "Instalar Aplicación (PWA)",
  "player.settings.installAppDesc": "Añade Mister11 a tu pantalla de inicio para acceso rápido sin descargas.",
  "player.settings.language": "Idioma de la Aplicación",
  "player.settings.modalTitle": "Configuración y Preferencias",
  "player.settings.notifications": "Recordatorios de Sesión",
  "player.settings.notificationsDesc": "Recibe notificaciones 1h antes de entrenamientos y partidos.",
  "player.settings.sessionTitle": "Sesión y Cuenta",
  "player.settings.switchModeTitle": "Rol y Permisos",
  "player.settings.theme": "Modo Oscuro",
  "player.shareConsent": "Compartir Consentimiento Parental",
  "player.starter": "Titular",
  "player.stats.aboveAvg": "▲ +{xp} XP (Por encima de la media)",
  "player.stats.anonymousRgpd": "🔒 Datos anónimos (RGPD)",
  "player.stats.areasInZero": "Áreas pendientes de medición",
  "player.stats.areasInZeroDesc": "El área Mental se activa completando cuestionarios en la pestaña Tests. Las áreas Física, Técnica y Táctica se actualizan con las evaluaciones de tu entrenador.",
  "player.stats.assists": "ASISTENCIAS",
  "player.stats.average": "Media:",
  "player.stats.avgRating": "NOTA MEDIA",
  "player.stats.axis.attendance": "ASISTENCIA",
  "player.stats.axis.mental": "MENTAL",
  "player.stats.axis.physical": "FÍSICO",
  "player.stats.axis.tactical": "TÁCTICA",
  "player.stats.axis.technical": "TÉCNICA",
  "player.stats.belowAvg": "▼ +{xp} XP (Por debajo de la media)",
  "player.stats.cards": "TARJETAS",
  "player.stats.disciplinarySanctions": "Sanciones disciplinarias",
  "player.stats.evolutionTitle": "Evolución Temporal de Tests",
  "player.stats.friendlyMatch": "Amistoso",
  "player.stats.globalXpSubtitle": "Asistencia + minutos + logros",
  "player.stats.globalXpTitle": "XP Global",
  "player.stats.goToTests": "Ir a Cuestionarios",
  "player.stats.goals": "GOLES",
  "player.stats.hideGuide": "Ocultar guía",
  "player.stats.hideInfo": "Ocultar info",
  "player.stats.howAxesMeasured": "¿Cómo se mide cada eje?",
  "player.stats.howIsMeasured": "¿Cómo se mide?",
  "player.stats.howIsMeasuredDesc": "Las asistencias y minutos se extraen de las actas oficiales del cuerpo técnico en estricto cumplimiento del RGPD.",
  "player.stats.inCompetition": "en competición",
  "player.stats.inMatch": "en {count} partido",
  "player.stats.inMatches": "en {count} partidos",
  "player.stats.keyPasses": "pases clave",
  "player.stats.leaderboardSubtitle": "Puntuación y compromiso en el vestuario",
  "player.stats.leaderboardTitle": "Leaderboard de Plantilla",
  "player.stats.makeTest": "Hacer test",
  "player.stats.matchHistory": "HISTORIAL DE PARTIDOS DISPUTADOS",
  "player.stats.matchHistorySync": "Sincronizado con actas del Míster",
  "player.stats.minutesPerMatch": "Minutos por partido",
  "player.stats.minutesPlayed": "MINUTOS",
  "player.stats.noAttRecorded": "● Sin sesiones registradas aún",
  "player.stats.noEvalsDesc": "Realiza los tests en la pestaña Tests o espera a que tu entrenador registre tus mediciones para ver tus gráficas de progresión.",
  "player.stats.noEvalsYet": "Sin evaluaciones registradas aún",
  "player.stats.noMatchesDesc": "Tus minutos, goles y convocatorias aparecerán aquí automáticamente tras cada jornada.",
  "player.stats.noMatchesRecorded": "● Sin partidos disputados aún",
  "player.stats.noMatchesYet": "Sin partidos registrados aún esta temporada",
  "player.stats.noTeamDataDesc": "Las métricas comparativas se activarán automáticamente cuando el míster registre asistencias o partidos en la plantilla.",
  "player.stats.noTeamDataYet": "● Aún sin datos suficientes del equipo",
  "player.stats.officialMatch": "Oficial",
  "player.stats.officialMatches": "PARTIDOS",
  "player.stats.officialRating": "Nota Media Oficial",
  "player.stats.officialSummaryTitle": "ESTADÍSTICAS OFICIALES 2026-27",
  "player.stats.onAvg": "● +{xp} XP (En la media)",
  "player.stats.pendingActaShort": "Pendiente de acta",
  "player.stats.radarAtt": "Asistencia: Porcentaje real de asistencia a entrenamientos y citaciones.",
  "player.stats.radarGuideTitle": "Fuente de información de cada dimensión (0 a 100):",
  "player.stats.radarLevel": "Nivel Global: {level}",
  "player.stats.radarMental": "Mental: Cuestionarios psicológicos (ACSI-28, MTQ-10), entrenamiento cognitivo en juegos y valoración del cuerpo técnico.",
  "player.stats.radarPhys": "Físico: Tests de resistencia, velocidad y fuerza o nota física asignada por el cuerpo técnico.",
  "player.stats.radarTact": "Táctica: Posicionamiento, toma de decisiones y lectura de juego evaluados por el míster.",
  "player.stats.radarTech": "Técnica: Control, pase, regate y finalización evaluados por el entrenador.",
  "player.stats.radarTitle": "RADAR DE HABILIDADES",
  "player.stats.realTime": "⚡ En tiempo real",
  "player.stats.seasonAverage": "Promedio de temporada",
  "player.stats.sourceAttendance": "Asistencia: Proviene de los registros oficiales de asistencia que toma el entrenador en cada sesión. Otorga +{xp} XP directos según tu porcentaje.",
  "player.stats.sourceAverage": "Media de la plantilla: Promedio agregado real del vestuario para comparar tu regularidad deportiva sin juicios negativos.",
  "player.stats.sourceInfoTitle": "¿De dónde provienen los datos y puntos XP de esta tabla?",
  "player.stats.sourceMatches": "Partidos / Minutos: Proviene de las actas de partido y convocatorias del míster. Otorga +{xp} XP proporcionales a tus minutos jugados sobre el total del equipo.",
  "player.stats.startsAndSubs": "{starts} tit. · {subs} sup.",
  "player.stats.title": "Estadísticas & Rendimiento",
  "player.stats.vsTeamTitle": "TÚ VS PROMEDIO DEL EQUIPO",
  "player.stats.wellnessTitle": "Bienestar Semanal (Wellness)",
  "player.stats.xpByParticipation": "+{xp} XP según tu {pct}% de participación",
  "player.stats.you": "Tú",
  "player.substitute": "Suplente",
  "player.syncNotice": "Los goles, alineaciones y minutos registrados en el módulo Partidos se sincronizarán aquí automáticamente.",
  "player.tab.attendance": "ASISTENCIA",
  "player.tab.chat": "CHAT",
  "player.tab.general": "GENERAL",
  "player.tab.health": "SALUD",
  "player.tab.physical": "FÍSICO",
  "player.tab.plans": "PLANES",
  "player.tab.settings": "AJUSTES",
  "player.weight": "Peso",
  "playerDashboard.new_message": "💬 Nuevo mensaje del Míster:",
  "playerProfile.ageLabel": "Edad",
  "playerProfile.bmi": "IMC",
  "playerProfile.bmiDesc": "Índice de Masa Corporal estimado.",
  "playerProfile.editTooltip": "Toca para editar tus medidas",
  "playerProfile.heightLabel": "Altura",
  "playerProfile.heightRangeError": "La altura debe estar entre 100 y 230 cm.",
  "playerProfile.heightUnit": "cm",
  "playerProfile.physicalStats": "Datos Físicos",
  "playerProfile.readOnlyNotice": "La edad, dorsal y posición solo pueden ser modificados por el cuerpo técnico.",
  "playerProfile.saveError": "Error al guardar los datos físicos.",
  "playerProfile.statsSaved": "Datos físicos actualizados correctamente.",
  "playerProfile.weightLabel": "Peso",
  "playerProfile.weightRangeError": "El peso debe estar entre 30 y 150 kg.",
  "playerProfile.weightUnit": "kg",
  "pos.all": "TODOS",
  "pos.def": "DEF",
  "pos.del": "DEL",
  "pos.ext": "EXT",
  "pos.ltd": "LTD",
  "pos.lti": "LTI",
  "pos.mc": "MC",
  "pos.mcd": "MCD",
  "pos.mco": "MCO",
  "pos.por": "POR",
  "pricing.badge.bestValueAcademies": "MÁS POPULAR CLUBES",
  "pricing.badge.mostPopularCoach": "MÁS ELEGIDO ENTRENADORES",
  "pricing.billing.discountBadge": "2 MESES GRATIS",
  "pricing.billing.monthly": "Mensual",
  "pricing.billing.season": "Pase Temporada (10 Meses)",
  "pricing.btn.selectClubPro": "SELECCIONAR CLUB PRO",
  "pricing.btn.selectPremium": "SELECCIONAR PREMIUM",
  "pricing.btn.selectStarter": "SELECCIONAR STARTER",
  "pricing.btn.startFree": "COMENZAR GRATIS",
  "pricing.btn.tryPro": "PROBAR 7 DÍAS GRATIS",
  "pricing.cancelAnytime": "Cancela cuando quieras sin compromiso.",
  "pricing.clubPro.attr1_strong": "Hasta 15 Equipos",
  "pricing.clubPro.attr1_text": "Hasta 10 staff por equipo",
  "pricing.clubPro.attr2_strong": "Informes Consolidados de Club",
  "pricing.clubPro.attr3_strong": "Histórico Global de Cantera y 24/7",
  "pricing.clubPro.vat": "~3,00 €/entrenador/mes · IVA incluido",
  "pricing.coachPro": "Entrenador PRO",
  "pricing.comparison.subtitle": "Analiza cada característica en detalle entre planes individuales y de club con entitlements verificados.",
  "pricing.comparison.thModule": "Módulo y Función",
  "pricing.comparison.title": "Matriz Comparativa Detallada de Características",
  "pricing.footer.install": "Instalar App / PWA",
  "pricing.footer.login": "Acceso Entrenadores",
  "pricing.footer.rgpd": "RGPD y Privacidad",
  "pricing.footer.rights": "Todos los derechos reservados. Paleta Oficial Tierra y Campo.",
  "pricing.footer.tagline": "La plataforma de inteligencia técnica para el fútbol base y amateur.",
  "pricing.free.attr1_strong": "1 Equipo",
  "pricing.free.attr1_text": "(23 jugadores) · 1 Entrenador",
  "pricing.free.attr2_strong": "10 Sesiones",
  "pricing.free.attr2_text": "Pizarra básica · 5 IA/mes",
  "pricing.free.attr3_strong": "Firma Digital RGPD",
  "pricing.free.attr3_text": "incluida",
  "pricing.freq.forever": "/ para siempre",
  "pricing.freq.month": "/ mes",
  "pricing.freq.season": "/ temporada",
  "pricing.freq.seasonShort": "/ temp.",
  "pricing.fullAccess": "Acceso total a todas las funciones avanzadas.",
  "pricing.header.subtitle": "Precios con IVA incluido. El pase de temporada cubre los 10 meses de competición oficial con Julio y Agosto gratis.",
  "pricing.header.title": "Planes Transparentes para Entrenadores y Clubes",
  "pricing.monthly": "Facturación mensual",
  "pricing.plan.clubPremium.name": "Club Premium",
  "pricing.plan.clubPremium.tagline": "Para academias de alto rendimiento y múltiples sedes",
  "pricing.plan.clubPro.name": "Club PRO",
  "pricing.plan.clubPro.tagline": "Para clubes estructurados con metodología propia",
  "pricing.plan.clubStarter.name": "Club Starter",
  "pricing.plan.clubStarter.tagline": "Para canteras y clubes en crecimiento",
  "pricing.plan.free.name": "Plan Gratuito",
  "pricing.plan.free.tagline": "Para empezar a digitalizar tu equipo",
  "pricing.plan.pro.name": "Plan PRO",
  "pricing.plan.pro.tagline": "Para el entrenador que quiere el máximo rendimiento",
  "pricing.premium.attr1_strong": "Hasta 40 Equipos",
  "pricing.premium.attr1_text": "Staff Ilimitado",
  "pricing.premium.attr2_strong": "Licencias Multi-Sede y Códigos",
  "pricing.premium.attr3_strong": "Onboarding Personalizado y VIP",
  "pricing.premium.vat": "IVA incluido · Soporte VIP",
  "pricing.pro.attr1_strong": "Hasta 3 Equipos",
  "pricing.pro.attr1_text": "Sesiones ilimitadas y Live Stats",
  "pricing.pro.attr2_strong": "Acta Oficial PDF 7 Páginas",
  "pricing.pro.attr2_text": "xG-Lite (105:68) y Portería",
  "pricing.pro.attr3_strong": "Portal del Jugador",
  "pricing.pro.attr3_text": "Wellness diario, Tests e IA ilimitada",
  "pricing.pro.vatMonthly": "Facturado mensual · Cancela cuando quieras",
  "pricing.pro.vatSeason": "Equivale a 6,90 €/mes · IVA incluido",
  "pricing.starter.attr1_strong": "Hasta 6 Equipos",
  "pricing.starter.attr1_text": "Hasta 4 staff por equipo",
  "pricing.starter.attr2_strong": "Todo lo incluido en el Plan PRO",
  "pricing.starter.attr3_strong": "Panel Multi-Entrenador con Roles",
  "pricing.starter.vat": "~5,50 €/entrenador/mes · IVA incluido",
  "pricing.subscribeNow": "Suscribirse Ahora",
  "pricing.vat.included": "IVA incluido",
  "push.foreground_toast": "🔔 {title}: {body}",
  "qrScanner.cameraPermissionError": "No se pudo acceder a la cámara. Revisa los permisos en tu navegador.",
  "qrScanner.hint": "Apunta la cámara al código QR proporcionado por el entrenador para unirte automáticamente al equipo.",
  "qrScanner.noQrInImage": "No se detectó ningún código QR en la imagen seleccionada.",
  "qrScanner.title": "Escanear Código QR de Equipo",
  "qrScanner.unsupportedBrowser": "Tu navegador o dispositivo no soporta la cámara.",
  "qrScanner.uploadQrPhoto": "Subir foto con QR",
  "rendimientoPdf.btnDownload": "Descargar PDF",
  "rendimientoPdf.chartsTitle": "Comparativa de Métricas por Jugador",
  "rendimientoPdf.generatedBy": "Generado por Mister11",
  "rendimientoPdf.matchDetails": "Detalles del Partido",
  "rendimientoPdf.subtitle": "Estadísticas individuales por jugador y métricas canónicas",
  "rendimientoPdf.tableTitle": "Tabla Completa de Rendimiento",
  "rendimientoPdf.title": "INFORME DE RENDIMIENTO INDIVIDUAL",
  "sector.activeZone": "Zona Activa: {zone}",
  "sesiones.actions.edit": "Editar",
  "sesiones.actions.share": "Compartir",
  "sesiones.blockCount.one": "{count} Bloque",
  "sesiones.blockCount.other": "{count} Bloques",
  "sesiones.categories.all": "Todas",
  "sesiones.categories.fisica": "Física",
  "sesiones.categories.general": "General",
  "sesiones.categories.mixta": "Mixta",
  "sesiones.categories.partido": "Partido",
  "sesiones.categories.tactica": "Táctica",
  "sesiones.categories.tecnica": "Técnica",
  "sesiones.clickDayToView": "Pulsa un día para ver sesiones",
  "sesiones.exportICS": "📅 Exportar ICS",
  "sesiones.fieldMode": "Modo Campo",
  "sesiones.importSession": "Importar Sesión",
  "sesiones.newSession": "+ Nueva Sesión",
  "sesiones.noDiagram": "Sin diagrama",
  "sesiones.preview.addBlock": "+ Añadir Bloque",
  "sesiones.preview.blocks": "BLOQUES",
  "sesiones.preview.deleteAnimation": "ELIMINAR",
  "sesiones.preview.deleteSession": "Eliminar Sesión",
  "sesiones.preview.editSession": "✏️ Editar Sesión",
  "sesiones.preview.emptyBlocks": "No hay bloques definidos.",
  "sesiones.preview.exportMp4": "🎬 EXPORTAR MP4",
  "sesiones.preview.exportPdf": "📄 Exportar a PDF",
  "sesiones.preview.generating": "⏳ Generando informe...",
  "sesiones.preview.googleCal": "📅 Google Cal",
  "sesiones.preview.ics": "📥 ICS",
  "sesiones.preview.load": "CARGA",
  "sesiones.preview.min": "MIN",
  "sesiones.preview.shareSession": "🔗 Compartir / Transferir Sesión",
  "sesiones.preview.startLiveField": "⏱️ Iniciar Modo Campo (Cronómetro & Voz)",
  "sesiones.preview.structure": "Estructura de la Sesión",
  "sesiones.preview.viewPdf": "Ver PDF",
  "sesiones.tab.animations": "Animaciones",
  "sesiones.tab.captures": "Capturas",
  "sesiones.tab.sessions": "Sesiones",
  "sesiones.title": "Sesiones de Entrenamiento",
  "sesiones.views.day": "DÍA",
  "sesiones.views.month": "MES",
  "sesiones.views.week": "SEMANA",
  "session.untitled": "Sin título",
  "sessionRating.averageRating": "Media",
  "sessionRating.commentPlaceholder": "Comentario técnico u observaciones (opcional, máx. 200 car.)",
  "sessionRating.evolutionTitle": "Evolución en Entrenamientos",
  "sessionRating.noRatings": "Aún no hay calificaciones registradas para esta sesión.",
  "sessionRating.performanceTableSubtitle": "Últimas 5 sesiones calificadas y media acumulada",
  "sessionRating.performanceTableTitle": "Rendimiento en Entrenos",
  "sessionRating.radarAxisTraining": "Entrenamiento",
  "sessionRating.rateButton": "Calificar",
  "sessionRating.ratingLabel": "Nota",
  "sessionRating.saveError": "Error al guardar las calificaciones de la sesión.",
  "sessionRating.saveRatings": "Guardar Calificaciones",
  "sessionRating.savedSuccess": "Calificaciones de entrenamiento guardadas correctamente.",
  "sessionRating.subtitle": "Evalúa el rendimiento de los jugadores convocados (0 a 10)",
  "sessionRating.title": "Calificación de la Sesión",
  "settings.teamIdentity": "Identidad del Equipo",
  "shot.badge_decisive": "DECISIVA",
  "shot.badge_normal": "NORMAL",
  "shot.blocked": "Finalização Bloqueada",
  "shot.cancel": "Cancelar",
  "shot.comfort": "Comodidad del Rematador",
  "shot.comfort_comfortable": "Cómodo",
  "shot.comfort_pressed": "Presionado",
  "shot.comfort_very_pressed": "Muy Presionado",
  "shot.confirm": "Registrar Tiro",
  "shot.diff_decisive": "Decisiva",
  "shot.diff_normal": "Normal",
  "shot.difficulty": "Dificultad de la Parada",
  "shot.goal": "Gol Marcado",
  "shot.missed": "Finalização para Fora",
  "shot.playType": "Tipo de Jugada",
  "shot.playType_balon_parado": "Balón Parado",
  "shot.playType_contra": "Contra",
  "shot.playType_jugada": "Jugada",
  "shot.playType_penalti": "Penalti",
  "shot.result": "Resultado del Tiro",
  "shot.result_bloqueado": "Bloqueado",
  "shot.result_fuera": "Fuera",
  "shot.result_gol": "Gol",
  "shot.result_parada": "Parada",
  "shot.saved": "Finalização Defendida",
  "shot.step1": "1. Resultado",
  "shot.step2": "2. Dificultad",
  "shot.step3": "3. Comodidad",
  "shot.team": "Equipo",
  "shot.team_own": "Propio",
  "shot.team_rival": "Rival",
  "shot.title": "Registrar Tiro con Contexto",
  "shot.zone": "Zona de Remate",
  "shot.zone_inside_center": "Centro (Área)",
  "shot.zone_inside_left": "Banda Izq. (Área)",
  "shot.zone_inside_right": "Banda Der. (Área)",
  "shot.zone_outside_center": "Centro (Fuera)",
  "shot.zone_outside_left": "Banda Izq. (Fuera)",
  "shot.zone_outside_right": "Banda Der. (Fuera)",
  "shot.zone_penalty": "Punto de Penalti",
  "spell.addToDictionary": "Agregar al diccionario",
  "spell.allCorrect": "Sin observaciones ortográficas",
  "spell.ignore": "Ignorar",
  "spell.missingAccent": "Falta tilde",
  "spell.noSuggestions": "Sin sugerencias directas",
  "spell.observations": "{count} observación ortográfica",
  "spell.observationsPlural": "{count} observaciones ortográficas",
  "spell.recommended": "Sugerencias:",
  "spell.title": "Ortografía & Gramática",
  "spell.typo": "Error tipográfico",
  "spell.unrecognized": "Palabra no reconocida",
  "staff.cancelInvitation": "Cancelar invitación",
  "staff.changeRole": "Cambiar Rol:",
  "staff.copied": "¡Copiado!",
  "staff.copy": "Copiar",
  "staff.copyCode": "Copiar Código",
  "staff.copyLink": "Copiar Enlace",
  "staff.copyLinkDesc": "Copia y envía este enlace al miembro del cuerpo técnico para que se una al equipo:",
  "staff.createdDate": "Creada: {date}",
  "staff.generateLink": "⚡ Generar Enlace / Código",
  "staff.inviteGenerated": "¡Invitación Generada!",
  "staff.inviteLinkCopied": "Enlace de invitación copiado.",
  "staff.inviteModalDesc": "Introduce el correo electrónico y selecciona el rol. El usuario podrá acceder y colaborar en tiempo real.",
  "staff.inviteModalTitle": "Invitar Miembro al Cuerpo Técnico",
  "staff.inviteStaffBtn": "Invitar Staff ({count}/{limit})",
  "staff.pendingInvitations": "Invitaciones Pendientes ({count})",
  "staff.realtimeSync": "Equipo: {team} · Sincronización en tiempo real",
  "staff.remove": "Quitar",
  "staff.removeConfirm": "¿Estás seguro de eliminar a {name} del cuerpo técnico?",
  "staff.role.admin": "Primer Entrenador (Admin)",
  "staff.role.analyst": "Analista Táctico",
  "staff.role.assistant": "Ayudante / 3er Entrenador",
  "staff.role.assistantCoach": "Segundo Entrenador",
  "staff.role.coach": "Segundo Entrenador",
  "staff.role.collaborator": "Colaborador / Ayudante",
  "staff.role.coordinator": "Coordinador Metodológico",
  "staff.role.delegate": "Delegado de Campo",
  "staff.role.doctor": "Médico",
  "staff.role.fitness_coach": "Preparador Físico",
  "staff.role.goalkeeperCoach": "Entrenador de Porteros",
  "staff.role.headCoach": "Primer Entrenador",
  "staff.role.physicalTrainer": "Preparador Físico",
  "staff.role.physio": "Fisioterapeuta",
  "staff.role.player": "Jugador",
  "staff.role.scout": "Ojeador / Scout",
  "staff.roleAssistantCoach": "Auxiliar Técnico",
  "staff.roleDesc.admin": "Control total: gestión del equipo, miembros, partidos, sesiones, salud y táctica.",
  "staff.roleDesc.analyst": "Registro y análisis de Live Stats en tiempo real, informes y analíticas.",
  "staff.roleDesc.assistant": "Registro de Live Stats, control de asistencia y apoyo en sesiones.",
  "staff.roleDesc.coach": "Edición de partidos, alineaciones, sesiones, pizarra, planning y asistencia.",
  "staff.roleDesc.fitness_coach": "Control de preparación física, cargas de entrenamiento, pruebas físicas y estado atlético.",
  "staff.roleDesc.physio": "Acceso y edición de historial médico, lesiones, tests físicos/wellness y asistencia.",
  "staff.roleDesc.player": "Acceso de solo lectura a su ficha individual, sesiones y calendario.",
  "staff.roleDoctor": "Médico",
  "staff.roleFitnessCoach": "Preparador Físico",
  "staff.roleGoalkeeperCoach": "Treinador de Goleiros",
  "staff.roleHeadCoach": "Treinador Principal",
  "staff.roleLabel": "Rol en el Cuerpo Técnico",
  "staff.rolePhysio": "Fisioterapeuta",
  "staff.roleScout": "Olheiro / Analista",
  "staff.sendInvite": "Enviar Invitación",
  "staff.shareCodeDesc": "Comparte este código para que los jugadores o sus padres se unan desde el Portal (/join-team).",
  "staff.shareLink": "Compartir Enlace",
  "staff.shareNative": "📲 Compartir Enlace (WhatsApp / Apps)",
  "staff.sixDigitCode": "Código de 6 dígitos:",
  "staff.staffTitle": "Cuerpo Técnico y Colaboradores",
  "staff.tab.active": "Comissão Ativa",
  "staff.tab.invites": "Convites",
  "staff.uniqueCodeTitle": "Código Único para Jugadores y Familias",
  "staff.you": "(Tú)",
  "staffHeredado.badgeActive": "Funciones PRO activas gracias al plan de {ownerName}",
  "staffHeredado.badgeActiveShort": "Plan Heredado ({ownerName})",
  "staffHeredado.gracePeriodBanner": "Aviso de suscripción: El plan del propietario ha cambiado. El equipo pasará a modo restringido en {days} días. Actualiza a PRO para mantener el acceso ilimitado.",
  "staffHeredado.gracePeriodBlocked": "Acceso restringido: El periodo de gracia del equipo ha expirado. El propietario debe reactivar el plan PRO para reanudar todas las funciones del staff.",
  "staffHeredado.restrictedFeatureStaff": "Esta función requiere que el equipo cuente con un plan PRO activo del propietario.",
  "staffHeredado.transferError": "Error al transferir la propiedad del equipo.",
  "staffHeredado.transferLimitExceeded": "Este usuario ya tiene un equipo en su plan gratuito. Debe actualizar a PRO para poder aceptar la propiedad de este equipo.",
  "staffHeredado.transferSuccess": "Propiedad del equipo transferida con éxito a {userName}.",
  "staffInvite.cardSubtitle": "Código exclusivo para vincular colaboradores, preparadores y analistas al cuerpo técnico.",
  "staffInvite.cardTitle": "CÓDIGO DE ACCESO PARA ENTRENADORES/STAFF",
  "staffInvite.codeCopied": "Código de staff copiado",
  "staffInvite.copyCode": "Copiar Código",
  "staffInvite.copyLink": "Copiar Enlace",
  "staffInvite.downloadQr": "Descargar Imagen QR",
  "staffInvite.emailLabel": "Correo electrónico del colaborador:",
  "staffInvite.inputPlaceholder": "Ej. ABC123 o STF-ABC123",
  "staffInvite.inviteEmail": "Invitar por Email",
  "staffInvite.joinBtn": "UNIRME AL EQUIPO",
  "staffInvite.joinSubtitle": "Si has sido invitado por el míster principal, ingresa tu código aquí.",
  "staffInvite.joinTitle": "CÓDIGO DE ACCESO PARA ENTRENADORES/STAFF",
  "staffInvite.linkCopied": "Enlace de staff copiado",
  "staffInvite.messageLabel": "Mensaje de invitación:",
  "staffInvite.modalTitle": "Invitar Miembro del Cuerpo Técnico",
  "staffInvite.qrCopied": "Enlace copiado",
  "staffInvite.qrModal": "Ver QR de Staff",
  "staffInvite.qrModalTitle": "Código QR de Invitación para Staff",
  "staffInvite.qrSubtitle": "El entrenador invitado puede escanear este código con su móvil para unirse al cuerpo técnico:",
  "staffInvite.roleLabel": "Rol asignado:",
  "staffInvite.sendBtn": "Enviar Invitación",
  "staffInvite.sendSuccess": "Invitación enviada con éxito.",
  "staffInvite.shareLink": "Compartir Enlace",
  "staffJoin.assignedRole": "Rol Asignado:",
  "staffJoin.btnSubmit": "Buscar y Unirme",
  "staffJoin.confirmJoin": "CONFIRMAR Y UNIRME AL STAFF",
  "staffJoin.errors.invalidCode": "Código de staff no válido o expirado. Contacta al míster.",
  "staffJoin.inputPlaceholder": "Ej. STF-ABC123 o ABC123",
  "staffJoin.linkPlaceholder": "https://mister11.com/join-staff?code=ABC123",
  "staffJoin.orPasteLink": "¿Tienes un enlace de invitación? Pégalo aquí:",
  "staffJoin.searching": "Validando código en tiempo real...",
  "staffJoin.subtitle": "Ingresa el código de 6 caracteres proporcionado por el entrenador principal o pega el enlace de invitación.",
  "staffJoin.success": "¡Te has unido con éxito al Cuerpo Técnico!",
  "staffJoin.teamFound": "Equipo Encontrado:",
  "staffJoin.title": "Unirse al Cuerpo Técnico",
  "stats.eventMap.guide": "Distribución territorial de las intervenciones del equipo (recuperaciones, duelos, tiros y faltas). Indica dónde está trabajando, ganando disputas o sufriendo el equipo en el terreno de juego.",
  "stats.eventMap.pass_insufficient": "Red de pases no disponible: Se requieren al menos 5 pases registrados para generar la red táctica. Se muestra el mapa de intervenciones por zona.",
  "stats.eventMap.title": "Mapa de Eventos por Zona",
  "stats.passNetwork.guide": "Cada nodo representa la posición media del jugador y el grosor de las líneas indica el volumen de pases entre compañeros. Permite identificar las sociedades clave y la fluidez asociativa en la salida de balón.",
  "stats.theater.close": "Cerrar modo teatro",
  "stats.theater.exit_fullscreen": "Salir de Pantalla Completa",
  "stats.theater.fullscreen": "Pantalla Completa",
  "stats.theater.theater_mode": "Modo Teatro",
  "status.none": "Sin Seleccionar",
  "swot.add_manual": "Agregar observación manual",
  "swot.ai_summary_title": "Resumen Táctico (IA)",
  "swot.auto_badge": "Regla",
  "swot.btn_generate_ai": "Redactar resumen con IA",
  "swot.generating_ai": "Redactando con IA...",
  "swot.manual_badge": "Manual",
  "swot.no_items": "Sin observaciones registradas para este cuadrante.",
  "swot.opportunities": "Oportunidades",
  "swot.origin_metric": "Métrica origen",
  "swot.rule.central_box_leak": "Vulnerabilidad en el pasillo central dentro del área propia.",
  "swot.rule.counter_efficiency": "Peligro constante y transiciones rápidas al contragolpe.",
  "swot.rule.duels_fragility": "Baja tasa de éxito en disputas divididas comprometiendo la posesión.",
  "swot.rule.duels_superiority": "Dominio territorial y contundencia en los duelos individuales.",
  "swot.rule.gk_decisive_hero": "Portería determinante con intervenciones decisivas de alto mérito.",
  "swot.rule.gk_high_exertion": "Alta exigencia sobre el guardameta debido a llegadas rivales frecuentes.",
  "swot.rule.high_attendance_cohesion": "Excelente constancia de presencia de plantilla y sincronización del bloque.",
  "swot.rule.high_xg_diff": "Alto volumen de generación ofensiva superando al rival en ocasiones claras.",
  "swot.rule.late_fatigue": "Goles o remates encajados en los últimos 15 minutos reflejan fatiga.",
  "swot.rule.low_xg_conv": "Ocasiones generadas con baja conversión a gol, requiriendo afinar la definición.",
  "swot.rule.rival_high_comfort": "El rival remata con excesiva comodidad sin oposición defensiva cercana.",
  "swot.rule.set_piece_threat": "Ocasiones concedidas a balón parado requieren mayor atención de marcas.",
  "swot.rule.wing_defense_solid": "Control efectivo de los pasillos laterales reduciendo peligro rival.",
  "swot.strengths": "Fortalezas",
  "swot.threats": "Amenazas",
  "swot.title": "Matriz DAFO Trazable",
  "swot.weaknesses": "Debilidades",
  "team.squadCount.one": "{count} jugador en la plantilla",
  "team.squadCount.other": "{count} jugadores en la plantilla",
  "team.title": "Mi Equipo",
  "teamMembers.admin_only_remove": "Solo el Primer Entrenador (Admin) puede eliminar miembros del equipo.",
  "teamMembers.already_member": "Este usuario ya es miembro del cuerpo técnico.",
  "teamMembers.invite_cancelled": "Invitación cancelada.",
  "teamMembers.invite_generated": "Enlace y código de invitación generados con éxito.",
  "teamMembers.member_removed": "Miembro eliminado del cuerpo técnico.",
  "teamMembers.role_updated": "Rol actualizado a {role}.",
  "teamQr.codeCopiedToast": "Código del equipo copiado al portapapeles",
  "teamQr.copied": "Copiado",
  "teamQr.copyCode": "Copiar Código",
  "teamQr.downloadImage": "Descargar Imagen QR",
  "teamQr.linkCopiedToast": "Enlace de invitación copiado al portapapeles",
  "teamQr.modalTitle": "Código QR y Enlace de Acceso al Equipo",
  "teamQr.scanInstructions": "Muestra este código QR a los jugadores o comparte el enlace directo para que se unan al equipo:",
  "teamQr.shareLink": "Compartir Enlace",
  "teamQr.teamCodeLabel": "Código de Acceso:",
  "test.answeringAll": "Por favor responde todas las preguntas del test.",
  "test.auto.acsi28.cat": "Afrontamiento y Presión",
  "test.auto.acsi28.desc": "Evalúa tu capacidad para mantener la calma ante errores, soportar la presión del rival y concentrarte en momentos clave.",
  "test.auto.acsi28.name": "ACSI-28 (Afrontamiento Deportivo)",
  "test.auto.acsi28.q1": "Mantengo la calma y una actitud positiva aunque el equipo vaya perdiendo.",
  "test.auto.acsi28.q2": "Si cometo un error o pierdo un balón, lo olvido rápido y me concentro en la siguiente jugada.",
  "test.auto.acsi28.q3": "Me mantengo concentrado en el partido a pesar de los gritos o distracciones externas.",
  "test.auto.acsi28.q4": "Puedo enfocarme al 100% en la tarea táctica que me pide el míster.",
  "test.auto.acsi28.q5": "Siento total seguridad en mis habilidades antes de saltar al campo.",
  "test.auto.acsi28.q6": "En los minutos finales o momentos decisivos juego con la misma soltura sin atenazarme.",
  "test.auto.acsi28.q7": "Acepto las correcciones del entrenador entendiendo que son para hacerme mejor jugador.",
  "test.auto.acsi28.q8": "Me adapto rápidamente si el míster me cambia de posición o rol durante el partido.",
  "test.auto.acsi28.short": "ACSI-28",
  "test.auto.geq.cat": "Cohesión y Vestuario",
  "test.auto.geq.desc": "Evalúa la unión del grupo, la comunicación entre compañeros y el sentido de pertenencia en el equipo.",
  "test.auto.geq.name": "GEQ (Cohesión de Equipo y Clima)",
  "test.auto.geq.q1": "Todos en el vestuario remamos en la misma dirección para alcanzar los objetivos.",
  "test.auto.geq.q2": "Nos apoyamos y animamos mutuamente cuando alguien comete un fallo.",
  "test.auto.geq.q3": "Existe un ambiente sano, divertido y de compañerismo fuera del campo.",
  "test.auto.geq.q4": "Me siento 100% valorado e integrado en este equipo.",
  "test.auto.geq.short": "Cohesión GEQ",
  "test.auto.goals.cat": "Metas y Enfoque",
  "test.auto.goals.desc": "Evalúa cómo planificas tus objetivos técnicos y físicos para superarte semana a semana.",
  "test.auto.goals.name": "Escala de Establecimiento de Metas",
  "test.auto.goals.q1": "Tengo claro qué aspectos técnicos o físicos debo mejorar este mes.",
  "test.auto.goals.q2": "Me esfuerzo extra en los ejercicios que me resultan más difíciles.",
  "test.auto.goals.q3": "Reviso mis partidos y entrenos para ver qué puedo hacer mejor la próxima vez.",
  "test.auto.goals.short": "Metas Individuales",
  "test.auto.mhc.cat": "Bienestar Psicodeportivo",
  "test.auto.mhc.desc": "Mide tu disfrute por el fútbol, satisfacción personal y sensación de progreso como deportista.",
  "test.auto.mhc.name": "MHC-SF (Bienestar Emocional)",
  "test.auto.mhc.q1": "Disfruto y me siento feliz cada vez que voy a entrenar o jugar.",
  "test.auto.mhc.q2": "Siento que el fútbol me ayuda a ser mejor persona y desarrollar disciplina.",
  "test.auto.mhc.q3": "Tengo una relación de confianza y respeto con el cuerpo técnico.",
  "test.auto.mhc.short": "Bienestar Mental",
  "test.auto.mtq10.cat": "Fortaleza Mental",
  "test.auto.mtq10.desc": "Mide tu determinación, perseverancia y cómo transformas los momentos difíciles en oportunidades de crecimiento.",
  "test.auto.mtq10.name": "MTQ-10 (Fortaleza y Resiliencia)",
  "test.auto.mtq10.q1": "Mantengo el control emocional cuando el árbitro o una jugada no sale como esperaba.",
  "test.auto.mtq10.q2": "Cumplo con los entrenamientos y el plan físico incluso los días que no tengo motivación.",
  "test.auto.mtq10.q3": "Veo los rivales difíciles y los desafíos como una oportunidad para demostrar mi nivel.",
  "test.auto.mtq10.q4": "Confío en mi capacidad para superar cualquier bache de juego o suplencia.",
  "test.auto.mtq10.q5": "No me rindo jamás hasta que el árbitro pita el final del encuentro.",
  "test.auto.mtq10.short": "Fortaleza MTQ",
  "test.auto.rpe.cat": "Carga y Esfuerzo Físico",
  "test.auto.rpe.desc": "Registra la intensidad del esfuerzo percibido tras tu último entrenamiento o partido en la escala validada Borg 1-10.",
  "test.auto.rpe.name": "RPE (Escala Borg CR-10)",
  "test.auto.rpe.q1": "¿Qué nivel de intensidad o esfuerzo físico sentiste en tu última sesión o partido?",
  "test.auto.rpe.short": "RPE Esfuerzo",
  "test.backToCatalog": "Volver al catálogo de tests",
  "test.category.aerobic": "Aeróbico e Resistência",
  "test.category.anaerobic": "Potência Anaeróbica",
  "test.category.flexibility": "Flexibilidade",
  "test.category.speed": "Velocidade e Sprint",
  "test.category.strength": "Força e Potência",
  "test.completedBadge": "Completado",
  "test.completedSuccess": "¡Test {name} completado con éxito! ({pct}%)",
  "test.dim.belonging": "Pertenencia",
  "test.dim.challenge": "Desafío",
  "test.dim.coachability": "Entrenabilidad",
  "test.dim.commitment": "Compromiso",
  "test.dim.concentration": "Concentración",
  "test.dim.confidence": "Confianza",
  "test.dim.coping": "Afrontamiento",
  "test.dim.emotionalControl": "Control Emocional",
  "test.dim.goalClarity": "Claridad de Objetivos",
  "test.dim.groupSupport": "Apoyo Grupal",
  "test.dim.perceivedEffort": "Esfuerzo Percibido",
  "test.dim.perseverance": "Perseverancia",
  "test.dim.purpose": "Propósito",
  "test.dim.selfAnalysis": "Autoanálisis",
  "test.dim.selfOvercoming": "Superación",
  "test.dim.socialCohesion": "Cohesión Social",
  "test.dim.sportsJoy": "Disfrute Deportivo",
  "test.dim.staffTrust": "Confianza Staff",
  "test.dim.taskCohesion": "Cohesión de Tarea",
  "test.dim.underPressure": "Rendimiento bajo presión",
  "test.dimension": "Dimensión",
  "test.errorSaving": "Error al guardar el test. Inténtalo de nuevo.",
  "test.finishAndSend": "FINALIZAR Y ENVIAR AL MÍSTER",
  "test.initialEvaluationRegistered": "Evaluación inicial registrada",
  "test.lastResult": "Último resultado",
  "test.of": "de",
  "test.opt.agree": "De acuerdo",
  "test.opt.almostAlways": "Casi siempre",
  "test.opt.almostNever": "Casi nunca",
  "test.opt.always": "Siempre",
  "test.opt.disagree": "En desacuerdo",
  "test.opt.little": "Poco de acuerdo",
  "test.opt.mostTimes": "La mayoría de veces",
  "test.opt.never": "Nunca",
  "test.opt.notAtAll": "Nada de acuerdo",
  "test.opt.often": "A menudo",
  "test.opt.quite": "Bastante de acuerdo",
  "test.opt.quiteAgree": "Bastante de acuerdo",
  "test.opt.rarely": "Raras veces",
  "test.opt.rpe1": "1 - Muy suave (recuperación)",
  "test.opt.rpe10": "10 - Esfuerzo Máximo (límite absoluto)",
  "test.opt.rpe2": "2 - Suave (cómodo)",
  "test.opt.rpe3": "3 - Moderado (aeróbico constante)",
  "test.opt.rpe4": "4 - Algo duro (se siente el cansancio)",
  "test.opt.rpe5": "5 - Duro (esfuerzo notable)",
  "test.opt.rpe6": "6 - Bastante duro",
  "test.opt.rpe7": "7 - Muy duro (alta intensidad)",
  "test.opt.rpe8": "8 - Muy duro + (cerca del límite)",
  "test.opt.rpe9": "9 - Extenuante",
  "test.opt.sometimes": "A veces",
  "test.opt.somewhatDisagree": "Poco de acuerdo",
  "test.opt.stronglyAgree": "Totalmente de acuerdo",
  "test.opt.stronglyDisagree": "Totalmente en desacuerdo",
  "test.previous": "Anterior",
  "test.question": "Pregunta",
  "test.questionProgress": "Pregunta {current} de {total}",
  "test.questionsCount": "{count} preguntas",
  "test.repeatTest": "Repetir Test",
  "test.retakeTest": "Repetir Cuestionario",
  "test.saveAnswers": "Guardar y Finalizar",
  "test.saving": "Guardando...",
  "test.startTest": "Iniciar Cuestionario",
  "test.successSaved": "Test completado y registrado en tu expediente.",
  "test.tabSubtitle": "Completa estos cuestionarios desde tu móvil para potenciar tu mentalidad, concentración y cohesión con el equipo.",
  "test.tabTitle": "Tests & Autoevaluaciones",
  "test.timeEstimate": "{minutes} min aprox.",
  "tests.alertResetConfirm": "¿Estás seguro de que deseas reiniciar los datos de la temporada?",
  "tests.attention": "⚠️ ATENCIÓN",
  "tests.catalogPhysical": "Catálogo de Pruebas: FÍSICOS",
  "tests.catalogPsychosocial": "Catálogo de Pruebas: PSICOSOCIALES",
  "tests.confirm_delete": "Confirmar eliminación",
  "tests.confirm_season_reset": "Reiniciar Temporada",
  "tests.createTest": "+ Crear Test",
  "tests.demoData": "🎯 Datos Demo",
  "tests.demoDataTooltip": "Inserta evaluaciones ficticias para ver cómo funcionan las gráficas",
  "tests.demoSuccess": "¡Datos de demostración cargados con éxito!",
  "tests.error": "Error",
  "tests.exportReport": "Exportar Informe",
  "tests.insert_demo": "Insertar datos demo",
  "tests.matrix.exportTeamReport": "Exportar Informe Colectivo",
  "tests.matrix.initialEval": "Eval Inicial",
  "tests.matrix.latestEval": "Última Eval",
  "tests.matrix.number": "Dorsal",
  "tests.matrix.player": "Jugador",
  "tests.matrix.previousEval": "Penúltima Eval",
  "tests.matrix.progress": "Evolución",
  "tests.matrix.title": "MATRIZ DE PLANIFICACIÓN",
  "tests.metricUnit": "Medida: ",
  "tests.modal.cancel": "CANCELAR",
  "tests.modal.confirm": "ACEPTAR",
  "tests.modal.downloadTemplate": "Descargar Plantilla de Toma de Datos",
  "tests.modal.execution": "Ejecución:",
  "tests.modal.executionProtocol": "PROTOCOLO DE EJECUCIÓN",
  "tests.modal.goToRecord": "Ir a Registrar Resultados",
  "tests.modal.measurement": "Medición:",
  "tests.modal.noProtocol": "No se ha especificado un protocolo detallado para esta prueba.",
  "tests.modal.objective": "Objetivo:",
  "tests.modal.objectiveDesc": "OBJETIVO Y DESCRIPCIÓN",
  "tests.modal.recordTitle": "Registro:",
  "tests.modal.rfefBadge": "Baremo Oficial RFEF (Percentiles Masculino y Femenino)",
  "tests.modal.rfefTooltip": "Fuente: Real Federación Española de Fútbol (RFEF) - Baremos de Condición Física en Fútbol Formativo Femenino (Salto Horizontal Pies Juntos).",
  "tests.modal.unit": "Unidad de medida:",
  "tests.modal.unitLabel": "Unidad: ",
  "tests.newModal.category": "Categoría Específica",
  "tests.newModal.categoryPlaceholder": "Ej. Resistencia, Psicología...",
  "tests.newModal.desc": "Descripción rápida",
  "tests.newModal.descPlaceholder": "Resumen del test",
  "tests.newModal.name": "Nombre del Test",
  "tests.newModal.namePlaceholder": "Ej. RM Sentadilla",
  "tests.newModal.physical": "Físico",
  "tests.newModal.protocol": "Protocolo de Ejecución Completo",
  "tests.newModal.protocolPlaceholder": "Pasos exactos de cómo se realiza la prueba en campo...",
  "tests.newModal.psychosocial": "Psicosocial",
  "tests.newModal.socioemotional": "Socioemocional",
  "tests.newModal.tactical": "Táctico",
  "tests.newModal.title": "Nuevo Test",
  "tests.newModal.type": "Tipo de Test",
  "tests.newModal.unit": "Unidad de medida",
  "tests.newModal.unitPlaceholder": "Ej. kg, seg, pts",
  "tests.record": "REGISTRAR",
  "tests.resetSeason": "🗑️ Reiniciar Temporada",
  "tests.resetSeasonTooltip": "Elimina todos los datos de evaluaciones de los jugadores para iniciar una nueva temporada",
  "tests.resources.drillDatabase": "Ejercicios",
  "tests.resources.myTeam": "Mi Plantilla",
  "tests.resources.seasonReport": "Informe de Temporada",
  "tests.resources.tacticalLibrary": "Pizarra Táctica",
  "tests.resources.tacticalTest": "Evaluación Táctica",
  "tests.resources.teamChat": "Chat de Equipo",
  "tests.resources.title": "Recursos y Herramientas",
  "tests.rpe.cancel": "CANCELAR",
  "tests.rpe.save": "GUARDAR RPE",
  "tests.saveResults": "Guardar Resultados",
  "tests.success": "Éxito",
  "tests.tab.comparativa": "Comparativa",
  "tests.tab.fisicos": "Tests Físicos",
  "tests.tab.historial": "Historial",
  "tests.tab.prevencion": "Prevención y Salud",
  "tests.tab.psicosociales": "Psicosociales",
  "tests.template": "PLANTILLA",
  "tests.title": "EVALUACIÓN Y TESTS",
  "tests.validation": "Validación",
  "tests.wellness.save": "Guardar Evaluación",
  "wellness.fatigue": "Nível de Fadiga",
  "wellness.mood": "Humor / Disposição",
  "wellness.rpe.cancel": "CANCELAR",
  "wellness.rpe.desc": "Registra cómo percibió el esfuerzo {name}.",
  "wellness.rpe.durationLabel": "Duración de la sesión (minutos)",
  "wellness.rpe.levelLabel": "Nivel de Esfuerzo (RPE 1-10)",
  "wellness.rpe.save": "GUARDAR RPE",
  "wellness.rpe.scaleMax": "10 - Máximo esfuerzo",
  "wellness.rpe.scaleMin": "1 - Muy suave",
  "wellness.rpe.title": "Registro de Esfuerzo Percibido (RPE)",
  "wellness.rpe.trainingLoad": "Carga de Entrenamiento (RPE × Duración):",
  "wellness.sleep": "Qualidade do Sono",
  "wellness.soreness": "Dor Muscular",
  "wellness.stress": "Nível de Estresse",
  "whiteboard.exportError": "Error al exportar el video MP4. Inténtalo de nuevo.",
  "whiteboard.exportRetry": "Reintentar exportación",
  "whiteboard.exportSuccess": "Video MP4 exportado con éxito.",
  "whiteboard.exportingFrame": "Exportando frame {current} de {total}...",
  "xg.box_center": "Área Central",
  "xg.box_wings": "Área Lateral",
  "xg.decisive_pct": "% Decisivas Exitosas",
  "xg.decisive_saves": "Paradas Decisivas",
  "xg.demanding_match": "Tarde Exigente",
  "xg.desc": "Probabilidad estadística de gol basada en zona, comodidad y tipo de jugada.",
  "xg.exposure_map": "Mapa de Exposición Defensiva",
  "xg.gk_exertion": "Índice de Exigencia GK",
  "xg.label": "Expected Goals (xG)",
  "xg.normal_match": "Exigencia Controlada",
  "xg.normal_saves": "Paradas Normales",
  "xg.outside_box": "Fuera del Área",
  "xg.own_xg": "xG Propio",
  "xg.penalty_box": "Penalti",
  "xg.rival_comfort": "Comodidad Rival",
  "xg.rival_xg": "xG Rival",
  "xg.save_pct": "% Eficacia Paradas",
  "xg.title": "Modelo xG-Lite & Exposición",
  "xg.totalTeam": "xG Total do Time",
  "xg.total_saves": "Total Paradas",
  "clinical.fallbackChip": "contenido clínico en español",
  "landing.footer.languages": "Idiomas",
  "landing.footer.rights": "Todos los derechos reservados.",
  "landing.hero.badge": "EL CEREBRO DIGITAL DEL ENTRENADOR",
  "landing.hero.btnPrimary": "PROBAR 7 DÍAS GRATIS",
  "landing.hero.btnSecondary": "VER PLANES Y TARIFAS",
  "landing.hero.desc": "Pizarra táctica interactiva, registro en vivo con proporción reglamentaria FIFA 105:68, prevención de lesiones con IA, tests psicométricos validados y actas oficiales en PDF.",
  "landing.hero.title_highlight": "nivel profesional",
  "landing.hero.title_part1": "Lleva tu metodología de entrenamiento al",
  "landing.nav.login": "INICIAR SESIÓN",
  "landing.nav.selectLang": "Seleccionar idioma",
  "landing.nav.themeToggle": "Cambiar tema",
  "landing.preview.title": "Pizarra Táctica Mister11 · Campo y Fichas",
  "landing.trust.noCard": "Sin tarjeta de crédito",
  "landing.trust.platforms": "Web, PWA y Android",
  "landing.trust.trial": "7 días de prueba total",
  "pricing.toggle.monthly": "Mensual",
  "pricing.toggle.season": "Pase Temporada (Recomendado)",
  "pdf.trainingSheet": "FICHA DE ENTRENAMIENTO",
  "pdf.date": "FECHA",
  "pdf.time": "HORA",
  "pdf.duration": "DURACIÓN",
  "pdf.intensity": "INTENSIDAD",
  "pdf.category": "CATEGORÍA",
  "pdf.material": "MATERIAL",
  "pdf.blocks": "BLOQUES",
  "pdf.mainTacticalDiagram": "DIAGRAMA TÁCTICO PRINCIPAL",
  "pdf.trainingBlocks": "BLOQUES DE ENTRENAMIENTO",
  "pdf.convocation": "CONVOCATORIA",
  "pdf.postSessionNotes": "NOTAS POST-SESION",
  "pdf.notesEmpty": "Sin notas registradas",
  "pdf.myTeam": "Mi Equipo",
  "pdf.footerBrand": "Mister11 Platform - mister11.app",
  "pdf.pageOf": "Pagina {cur} de {total}",
  "pdf.objectivePrefix": "Objetivo: ",
  "player.greet.hello": "¡Hola!",
  "player.join": "Unirme con Código",
  "player.ach.unlocked": "DESBLOQUEADOS",
  "player.tier.bronze": "Bronce",
  "player.tier.silver": "Plata",
  "player.tier.gold": "Oro",
  "player.period.biweekly": "Esta quincena",
  "player.profile.dominantFoot": "Pie dominante: {foot}",
  "player.profile.rightFoot": "Derecho",
  "player.profile.leftFoot": "Izquierdo",
  "player.profile.ambidextrous": "Ambidiestro",
  "player.consent.signEdit": "Firmar / Editar Consentimiento",
  "player.auth.switchToCoach": "Cambiar a Modo Entrenador",
  "player.auth.logout": "Cerrar Sesión",
  "player.auth.deleteAccount": "Eliminar Cuenta y Datos (RGPD)",
  "player.games.healthyTraining": "ENTRENAMIENTO SALUDABLE",
  "player.games.homeChallenges": "Retos en Casa",
  "player.games.reactionSpeed": "VELOCIDAD DE REACCIÓN",
  "player.games.workingMemory": "MEMORIA DE TRABAJO",
  "player.games.tacticalReading": "LECTURA TÁCTICA",
  "player.games.play": "JUGAR",
  "player.wellness.dailyCheckin": "CHECK-IN DIARIO DE BIENESTAR",
  "player.wellness.saveCheckin": "ENVIAR CHECK-IN DIARIO",
  "player.wellness.updateCheckin": "ACTUALIZAR ESTADO GENERAL",
  "player.wellness.medicalHistory": "Historial Médico y Lesiones",
  "player.wellness.recordInjury": "REGISTRAR MOLESTIA O LESIÓN",
  "player.plans.individualPlans": "Planes de Entrenamiento Individual",
  "player.plans.evolutionConstancy": "EVOLUCIÓN Y CONSTANCIA",
  "player.plans.activeCount": "{count} Planes Activos",
  "player.plans.allUpToDate": "¡Todo al día con tus planes!",
  "player.ach.tabs.vitrina": "Vitrina",
  "player.ach.tabs.games": "Juegos y Retos",
  "player.ach.tabs.ranking": "Ranking",
  "player.schedule.prevMonth": "Mes anterior",
  "player.schedule.nextMonth": "Mes siguiente",
  "player.schedule.calledUpTitle": "¡Convocado para el partido!",
  "player.schedule.reserveTitle": "Reserva / Convocatoria en espera",
  "player.schedule.notCalledTitle": "No convocado para esta jornada",
  "player.schedule.played": "jugados",
  "player.schedule.sheetClosed": "Acta oficial cerrada",
  "player.schedule.officialMinutes": "Minutos oficiales: {min}'",
  "player.schedule.dnp": "No jugaste en este partido",
  "player.schedule.parentPrompt": "¿Asistirá {name} a este evento?",
  "player.schedule.playerPrompt": "¿Asistirás a esta sesión?",
  "player.schedule.officialRecorded": "Asistencia oficial registrada por el cuerpo técnico",
  "player.schedule.pendingVerificationDesc": "Sesión realizada, pendiente de verificación del cuerpo técnico",
  "player.schedule.parentTrainingPrompt": "¿Asistirá {name} a este entrenamiento?",
  "player.schedule.playerTrainingPrompt": "¿Asistirás a este entrenamiento?",
  "player.schedule.photosCaptures": "Fotos y Capturas del Evento",
  "player.schedule.noEventsDesc": "Tu entrenador aún no ha programado sesiones o partidos en este mes.",
  "player.plans.active": "Activo",
  "player.plans.progressionHabit": "EVOLUCIÓN Y CONSTANCIA",
  "player.plans.activePlan": "Plan Activo",
  "player.plans.activePlans": "Planes Activos",
  "player.plans.youth": "Juvenil",
  "player.plans.monitoring": "Seguimiento",
  "player.plans.loading": "Cargando tus planes de entrenamiento...",
  "player.plans.upToDate": "¡Todo al día con tu preparación!",
  "player.plans.techRoutine": "Rutina Técnica y Preventiva",
  "player.plans.defaultPlanTitle": "Plan de Desarrollo Individual",
  "player.plans.coachInstructions": "Instrucciones del Míster:",
  "player.plans.todayExercises": "Ejercicios para Hoy:",
  "player.plans.doneCount": "hechos",
  "player.plans.markPending": "Marcar como pendiente",
  "player.plans.viewGuide": "Ver guía de ejecución técnica",
  "player.plans.guide": "Guía",
  "player.plans.notAgeSafe": "No apto para tu edad",
  "player.plans.ageSafeTooltip": "Este ejercicio requiere una edad mínima de {minAge} años por seguridad biomecánica.",
  "player.stats.evaluation": "Evaluación",
  "player.stats.general": "General",
  "player.stats.session": "Sesión",
  "player.stats.starter": "Titular",
  "player.stats.sub": "Suplente",
  "player.stats.pendingSheet": "Pendiente de acta",
  "player.stats.coachRating": "Nota del Míster",
  "player.stats.attitude": "Actitud",
  "player.stats.hitsVsMisses": "Aciertos vs Desaciertos",
  "player.stats.shotsOnTarget": "Tiros a puerta / total",
  "player.stats.duelsWon": "Duelos ganados / total",
  "player.stats.recoveriesLosses": "Recuperaciones vs Pérdidas",
  "player.stats.fouls": "faltas",
  "player.stats.bestStat": "Tu mejor dato del partido",
  "player.stats.youVsAverage": "Tú vs tu media de temporada",
  "player.stats.areasPending": "Áreas pendientes de medición",
  "player.stats.activeDiscomfort": "Molestia activa",
  "player.stats.available100": "100% Disponible",
  "player.stats.dailyProgression": "Evolución Diaria (Últimos 7 check-ins)",
  "player.stats.pain": "Dolor",
  "player.stats.ok": "OK",
  "player.stats.cleanSheet": "Imbatibilidad",
  "player.chat.defaultPlayerName": "este jugador",
  "player.home.defaultRole": "Jugador",
  "player.home.defaultCrack": "Crack",
  "player.home.calledUpSquad": "¡Estás en la convocatoria oficial de este partido!",
  "player.home.defaultLocation": "Campo de Entrenamiento",
  "stats.singleMatch": "1 partido",
  "stats.partidos": "partidos",
  "player.home.staffAuthor": "Cuerpo Técnico",
  "player.home.recent": "Reciente",
  "player.banner.perfProfile": "PERFIL DE RENDIMIENTO",
  "player.banner.noTestData": "Sin evaluaciones aún",
  "player.banner.perfMedal": "MEDALLA DE RENDIMIENTO",
  "player.profile.securityReauth": "Por motivos de seguridad, debes cerrar sesión e iniciarla de nuevo antes de eliminar tu cuenta.",
  "player.profile.deleteAccountError": "No se pudo eliminar la cuenta. Por favor contáctanos o reintenta tras reiniciar sesión.",
  "player.profile.matchesPlayedShort": "PJ",
  "player.profile.defaultCategory": "Juvenil",
  "player.profile.accountFallback": "Cuenta de Jugador",
  "player.wellness.saving": "Guardando...",
  "player.consent.parentPlaceholder": "Ej. Carlos Caicedo Pérez",
  "player.settings.notifDenied": "No se concedieron permisos de notificación.",
  "player.settings.remindersActivated": "Recordatorios activados.",
  "player.settings.languageUpdated": "Idioma actualizado",
  "player.settings.confirmLogout": "¿Deseas cerrar sesión?",
  "player.settings.toggleTheme": "Alternar tema claro/oscuro",
  "player.settings.toggleNotif": "Alternar notificaciones",
  "test.name.cooper": "Test de Cooper",
  "test.cat.endurance": "Físico · Resistencia",
  "test.name.navette": "Course Navette",
  "test.name.sprint10": "Sprint 10m",
  "test.cat.speed": "Físico · Velocidad",
  "test.name.sprint30": "Sprint 30m",
  "test.name.ttest": "T-Test (Agilidad)",
  "test.cat.agility": "Físico · Agilidad",
  "test.name.cmj": "Salto CMJ",
  "test.cat.power": "Físico · Fuerza",
  "test.name.cones": "Conducción conos",
  "test.cat.ballControl": "Técnica · Control",
  "test.name.shooting": "Pase a portería",
  "test.cat.accuracy": "Técnica · Precisión",
  "test.name.acsi28": "ACSI-28 (Afrontamiento)",
  "test.cat.pressure": "Mental · Presión",
  "test.name.mtq10": "MTQ-10 (Fortaleza Mental)",
  "test.cat.resilience": "Mental · Resiliencia",
  "test.name.goals": "Establecimiento de Metas",
  "test.cat.goals": "Mental · Objetivos",
  "test.name.leadership": "Liderazgo y Comunicación",
  "test.cat.leadership": "Mental · Liderazgo",
  "test.name.geq": "GEQ (Cohesión de Equipo)",
  "test.cat.cohesion": "Social · Cohesión",
  "test.name.mhc": "Escala Bienestar Mental",
  "test.cat.wellbeing": "Mental · Bienestar",
  "test.name.emotions": "Autoconciencia Emocional",
  "test.cat.emotions": "Mental · Emociones",
  "player.stats.pendingOfficialSheet": "Pendiente de confirmación oficial — Los datos aparecerán cuando el míster cierre el acta.",
  "stats.goles": "Goles",
  "stats.asistencias": "Asist.",
  "stats.minutos": "Minutos",
  "player.stats.goalsThisMatch": "Goles este partido",
  "player.stats.minutesThisMatch": "Minutos este partido",
  "player.stats.avgShort": "media",
  "player.stats.avgLabel": "Media",
  "player.stats.coachMessage": "Mensaje del Míster",
  "player.stats.discipline": "Disciplina",
  "player.stats.lastEval": "Última evaluación:",
  "player.tab.technical": "Técnica",
  "player.tab.tactical": "Táctica",
  "player.stats.trainingRatingDesc": "Calificación técnica en sesiones de entrenamiento",
  "player.stats.pendingRatings": "Pendiente de calificaciones",
  "player.stats.noRatingsYet": "Sin calificaciones de entrenamiento aún",
  "player.stats.ratingsInfoDesc": "El cuerpo técnico puede calificar el rendimiento y registrar notas técnicas tras cada entrenamiento desde el módulo de Sesiones.",
  "player.stats.weeklyWellness": "BIENESTAR Y RECUPERACIÓN SEMANAL",
  "player.stats.last7Days": "Últimos 7 días",
  "player.stats.sleepQuality": "CALIDAD SUEÑO",
  "player.stats.energyMood": "ENERGÍA / ÁNIMO",
  "player.stats.muscleStatus": "ESTADO MUSCULAR",
  "player.profile.sectionsAria": "Secciones del perfil de jugador",
  "player.banner.viewFullAnalytics": "Ver analíticas completas",
  "player.banner.techSummary": "Resumen técnico",
  "player.banner.renewTests": "Renovar cuestionarios y tests",
  "player.wellness.synced": "Sincronizado",
  "player.wellness.offlinePending": "Pendiente de sincronizar",
  "games.level.bronce": "Bronce",
  "games.level.plata": "Plata",
  "games.level.oro": "Oro",
  "games.level.diamante": "Diamante",
  "games.level.leyenda": "Leyenda",
  "games.levelUp": "¡Subiste a nivel {level}! (+10 XP)",
  "games.levelCeiling": "¡Alcanzaste el techo de Leyenda!",
  "games.g3.opponent": "Rival",
  "games.g3.teammate": "Compañero",
  "exercise.level": "Nivel"
};

export default es;
